(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWtiger_atlas_", frames: [[1298,3464,208,208],[1508,3464,176,176],[1498,2692,152,352],[1652,2692,152,352],[1344,2692,152,352],[1860,1602,162,358],[990,3026,162,358],[1860,1242,162,358],[1470,3256,214,206],[1688,3136,214,206],[1470,3046,216,208],[1252,3782,216,208],[772,3782,238,212],[1012,3782,238,212],[1686,3344,206,206],[1470,3674,206,206],[1470,3882,204,208],[1806,2918,238,216],[1806,2692,236,224],[1154,3088,238,236],[532,3782,238,226],[1860,1962,146,394],[1150,3386,146,394],[1196,2692,146,394],[1860,0,170,412],[1860,828,170,412],[1860,414,170,412],[1894,3370,136,220],[1904,3136,136,232],[372,0,370,600],[372,602,370,600],[744,602,370,600],[372,1806,370,600],[1116,602,370,600],[1488,602,370,600],[0,1204,370,600],[372,1204,370,600],[744,1204,370,600],[1116,1204,370,600],[1488,1204,370,600],[0,1806,370,600],[1488,0,370,600],[0,0,370,600],[0,2408,370,600],[0,3010,370,600],[744,1806,370,600],[744,0,370,600],[1116,0,370,600],[0,602,370,600],[1116,1806,370,600],[1488,1806,370,600],[990,2692,204,332],[372,3050,204,356],[532,3408,204,356],[578,2692,204,356],[738,3408,204,356],[784,2692,204,356],[578,3050,204,356],[372,2692,204,356],[784,3050,204,356],[944,3408,204,356],[372,2408,530,282],[904,2408,530,282],[1436,2408,530,282],[0,3612,530,300]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLegBack0003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLegBack0004 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLeg0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLeg0003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.TigerFrontLeg0004 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0010001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0010002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0020001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0020002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0030001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0030002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0040001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_0040002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_004_wet0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_roar_001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_roar_002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_roar_003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.TigerHead_roar_004 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLegBack0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLegBack0003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLegBack0004 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLeg0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLeg0003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.TigerHindLeg0004 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.TigerNeck = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.TigerNeck_wet = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20009 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20011 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20013 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20015 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20017 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20019 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20021 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20023 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20025 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20027 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20029 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20051 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20053 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20055 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20057 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20059 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20061 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20063 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20065 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20067 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.TigerTailLoop20069 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0003 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0005 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0007 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0009 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0011 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0013 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0015 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib.TigerTail_loop0017 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib.TigerTorso0001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib.TigerTorso0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib.TigerTorso_roar_001 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib.TigerTorso_wet0002 = function() {
	this.spriteSheet = ss["MWtiger_atlas_"];
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.tiger_pawGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AMzgiQAJAKAHAfQgBALgBAHQgEATgPAOQgHAGgIAFIgBAAQgCACgCABIgBAAQAAAAgBABQgBACgBABQgQAXgiAAIgRgBQgJgCgHgCQgMAFgQAAQgBAAgBAAQgBAAAAAAIgRgCQgFgBgEgBQgFAAgFABIgGAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAgBAAQAAAAgBAAIglgLQgIgGgFgJQgDgHgBgHIgBgFIAAAAQAAgJAAAAIAAgBQAAgLADgKQAEgPALgJQAAgBABgBQAAAAABAAIATgMQAKgEAMAAQAPAAAMAGQAIgDAKAAQADAAADABQAIgGAJgSQA1AJAcgGQAbgGAJALgAGJhkQAFgCATAAQATABASAGQASAHA2AaQgMAYgRARQgJAKgMAHQgRAKgWAFQgEACgDACIgaAEQgBAAAAAAIgQgBQgDAAgDgBQgIAAgHAAQgEABgFAAIgJABIgBAAQgFAAgFgBIgGAAQgGgBgFgCQgGABgHAAQgoAAgMgXQgEgGAAgIIgBgDIAAgJIAFgZQAEgLAJgJQAPgOAXAAQAOAAALAFQAHgCAJAAQALAAAJADQAJgCAJgHQADgCAFgDgAoIg3QB+ggAgBGQgNAXgbAlQgDADgDACQgBAMgfAWQghAXgWAAIgXAAQgGgBgYgJIAAAAQgBAAAAABQgMAEgQAAQgUAAgOgFQgJABgJAAQgyAAgPgeQgFgKgBgMQAAgKAAgBQAAgMADgKQgBAAgBAAQgGACgGABQgIACgJAAQgRAAgMgEQgIABgIAAQgrAAgNgZQgEgJgBgKQAAgJAAAAQAAgfATgSQARgQAZABQAPAAAMAFQAIgCAKAAQARAAAOAHQANgIARABQAEAAADAAQgBAAgCAAQAKgFAjAKQAjAKA/Afg");
	this.shape.setTransform(68.4,26.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.tiger_pawGlow, new cjs.Rectangle(-17.6,13.5,172,26.1), null);


(lib.tiger_mouthGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AA0iEQAuAGAMAJQAMAIAVASQAWASAAAsQAAAXgTAYQgIALgJAHQAEAMAAAOQAAAhgOAPQgZAdhWgEQhVgEgTgmQgOgaABgTQgHgDgGgDIgdgeQgNgWAAgUQAAg8A2gVQAWgJAJgDQBWgQAtAHg");
	this.shape.setTransform(16.5,12);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.tiger_mouthGlow, new cjs.Rectangle(-2,-3.5,37,31.1), null);


(lib.tiger_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 18
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AKPHaQgBgJAAgJQABgjgBgUQAAgEAAgDQgBgigIgQQgvhgg3hbQgJgOgKgPQgCALAAAIQAAANARBCQAJAhAIAfQAAAPgXApQgNAWgVAwQgVAwgjgPQgzgYgjgRQAEgEADgDQAMgNAOgQQAMgOAAgYQAAhGgahBQgJgXgwhcQgWgrgIgpQAogRA1gVQAGgCAIgCIAEgCQgBgBgBgBQgBgBAAgBQgBgBgBgBQAAgBgBgBQgBgBAAgBQgPgYgLgYQgJgZgIgWQgKgjAAgiQAAizA3hDQAwg5BLAeQBEAcA3BOQAOATAOAZQACAEABADQAZAzAAAvQAAABAAAAIAAABQAAABAAABQAAALgEAjQgIA7gRB+QAAB8A1BjQAOAZAXAnQAQAgAAAZQAAAfgCAbQgBAIgBAHQAAAhADAaQADAagjgJQheAJAHgYIgDAGQACgIACgBIAAAAIgBADAlxhiQAIBQgKAtQAAABAAABQAAACgBADIgNBnQgBAKgBALQgBAHAAAIIgCAPQgBAQgBARQgBABAAACQgJB3AABCQAAAQgJAkQgKAlgOADQgOAEgRgHQgQgGg9gyQAJgNAEgUIAAhqQgGA+gPAWQgOAWglArQgcAnhDhSQALgNAJgWQATgzgHgiQgIgjgMgYQgNgZgMgeQgMgfgNgmQgIgXgehpQBcBQA3AoQg4ifABgXQAYiKAXgdQAcg4AmgYQAvgfAsAMQAwAOAdA/QASBMALBVQAAgBABAAQAAAHABAIg");
	this.shape.setTransform(-34,50.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.tiger_legGlow, new cjs.Rectangle(-113.4,-1.9,158.9,104.5), null);


(lib.tiger_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ADXinIAigDQDegQgIBMQh4AXgKDWQhxA1ivAEQivAEhjgjQhigigyg0Qgyg0gMguQgMgvgGg1QgGg1AAAAIAOAGQAGADAHAEQAjAUASAIQAPAJANAFIAYAJQBRAUBagUQATgEAogGIB4gVQADAAADgBQADAAADgBIBogIQAcgFAvgBIAAAAQgEgBAOAAgADSinIAFAA");
	this.shape.setTransform(52.2,18.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.tiger_backGlow, new cjs.Rectangle(3.8,-2,96.7,41), null);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowpaws = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AMzgiQAJAKAHAfQgBALgBAHQgEATgPAOQgHAGgIAFIgBAAQgCACgCABIgBAAQAAAAgBABQgBACgBABQgQAXgiAAIgRgBQgJgCgHgCQgMAFgQAAQgBAAgBAAQgBAAAAAAIgRgCQgFgBgEgBQgFAAgFABIgGAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAgBAAQAAAAgBAAIglgLQgIgGgFgJQgDgHgBgHIgBgFIAAAAQAAgJAAAAIAAgBQAAgLADgKQAEgPALgJQAAgBABgBQAAAAABAAIATgMQAKgEAMAAQAPAAAMAGQAIgDAKAAQADAAADABQAIgGAJgSQA1AJAcgGQAbgGAJALgAGJhkQAFgCATAAQATABASAGQASAHA2AaQgMAYgRARQgJAKgMAHQgRAKgWAFQgEACgDACIgaAEQgBAAAAAAIgQgBQgDAAgDgBQgIAAgHAAQgEABgFAAIgJABIgBAAQgFAAgFgBIgGAAQgGgBgFgCQgGABgHAAQgoAAgMgXQgEgGAAgIIgBgDIAAgJIAFgZQAEgLAJgJQAPgOAXAAQAOAAALAFQAHgCAJAAQALAAAJADQAJgCAJgHQADgCAFgDgAoIg3QB+ggAgBGQgNAXgbAlQgDADgDACQgBAMgfAWQghAXgWAAIgXAAQgGgBgYgJIAAAAQgBAAAAABQgMAEgQAAQgUAAgOgFQgJABgJAAQgyAAgPgeQgFgKgBgMQAAgKAAgBQAAgMADgKQgBAAgBAAQgGACgGABQgIACgJAAQgRAAgMgEQgIABgIAAQgrAAgNgZQgEgJgBgKQAAgJAAAAQAAgfATgSQARgQAZABQAPAAAMAFQAIgCAKAAQARAAAOAHQANgIARABQAEAAADAAQgBAAgCAAQAKgFAjAKQAjAKA/Afg");
	this.shape.setTransform(68.4,26.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowpaws, new cjs.Rectangle(-17.6,13.5,172,26.1), null);


(lib.blueglowmouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AA0iEQAuAGAMAJQAMAIAVASQAWASAAAsQAAAXgTAYQgIALgJAHQAEAMAAAOQAAAhgOAPQgZAdhWgEQhVgEgTgmQgOgaABgTQgHgDgGgDIgdgeQgNgWAAgUQAAg8A2gVQAWgJAJgDQBWgQAtAHg");
	this.shape.setTransform(16.5,12);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmouth, new cjs.Rectangle(-2,-3.5,37,31.1), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 18
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AKPHaQgBgJAAgJQABgjgBgUQAAgEAAgDQgBgigIgQQgvhgg3hbQgJgOgKgPQgCALAAAIQAAANARBCQAJAhAIAfQAAAPgXApQgNAWgVAwQgVAwgjgPQgzgYgjgRQAEgEADgDQAMgNAOgQQAMgOAAgYQAAhGgahBQgJgXgwhcQgWgrgIgpQAogRA1gVQAGgCAIgCIAEgCQgBgBgBgBQgBgBAAgBQgBgBgBgBQAAgBgBgBQgBgBAAgBQgPgYgLgYQgJgZgIgWQgKgjAAgiQAAizA3hDQAwg5BLAeQBEAcA3BOQAOATAOAZQACAEABADQAZAzAAAvQAAABAAAAIAAABQAAABAAABQAAALgEAjQgIA7gRB+QAAB8A1BjQAOAZAXAnQAQAgAAAZQAAAfgCAbQgBAIgBAHQAAAhADAaQADAagjgJQheAJAHgYAKPHaIgBADIgDAGQACgIACgBgAlxhiQAIBQgKAtQAAABAAABQAAACgBADIgNBnQgBAKgBALQgBAHAAAIIgCAPQgBAQgBARQgBABAAACQgJB3AABCQAAAQgJAkQgKAlgOADQgOAEgRgHQgQgGg9gyQAJgNAEgUIAAhqQgGA+gPAWQgOAWglArQgcAnhDhSQALgNAJgWQATgzgHgiQgIgjgMgYQgNgZgMgeQgMgfgNgmQgIgXgehpQBcBQA3AoQg4ifABgXQAYiKAXgdQAcg4AmgYQAvgfAsAMQAwAOAdA/QASBMALBVQAAgBABAAQAAAHABAIg");
	this.shape.setTransform(-34,50.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-113.4,-1.9,158.9,104.5), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ADXinIAigDQDegQgIBMQh4AXgKDWQhxA1ivAEQivAEhjgjQhigigyg0Qgyg0gMguQgMgvgGg1QgGg1AAAAIAOAGQAGADAHAEQAjAUASAIQAPAJANAFIAYAJQBRAUBagUQATgEAogGIB4gVQADAAADgBQADAAADgBIBogIQAcgFAvgBIAAAAQgEgBAOAAgADSinIAFAA");
	this.shape.setTransform(52.2,18.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(3.8,-2,96.7,41), null);


(lib.TigerTorso_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,final_loop:1});

	// Layer 3
	this.instance = new lib.TigerTorso_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-146.5,-47.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-146.5,-47.4,265,150);


(lib.TigerTorso_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerTorso_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-146.5,-46.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTorso_roar_001_1, new cjs.Rectangle(-146.5,-47,265,141.1), null);


(lib.TigerTailStripes_009 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AhuK/QgSgJgGgIQgIgKAFgVQAGgdAXgeQAVgaAegdQAfgdAKACIAEAEIAGALIAGANQAKANAaANIAaAMQADAGgOAaQgOAbgkAeQgiAdgdAHQgNADgKAAQgOAAgLgFgAAhGbQALg/AFAAQAFAAAMAFQAMAGBTAGQARARgoBHQgZgChQgogAB3DrQgWAAgFgCQgGgCgPgBQgPgBABgmQABgnAEgHQAEgIANADIALADIARAEQAJABAeABQAegBATADQgGAZAAAZQgBAYgCAFQgBAGgWAAQgWgBgWAAgAA2AeIgMgsQgIgdADgYQAWgDAhgHQA/gOAegBQALAcAAAGIAAAJQAAACACADQAGARACAOIABAIQgDABAEAEIiJAfIgHAAgAgGjmQgCgJgJgNQgIgNgQggQgQgfAHgIQAGgIA4ghQA5ghAFgMQAGgMAOANQAOAOAPAuIAZBKQAJAbh/AXQgWALgIAAQgFAAgBgEgAigngQgYgGgMgZQgGgMgBgLQgIgfAIgjQAFgUAUg1QAUg2ApAgQAoAgAWAZQAXAZAEANQAJAjg7AvQgwAngbAAIgHgBg");
	this.shape.setTransform(-7.6,17.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTailStripes_009, new cjs.Rectangle(-28.4,-53,41.6,141.6), null);


(lib.TigerTailStripes_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AgEK+QgUgEgJgHQgJgHgBgWQgCgeAPgiQANgfAVgkQAWgkAKgBIAFADQACABAHAJQAGAHAEADQANAKAcAGIAcAFQAFAFgGAdQgHAdgbAmQgbAmgaAOQgXALgRAAIgFAAgAA3GQQgGg/AFgCQAFgCANADQANACBSgPQAVAMgUBPIgNABQgeAAhGgPgABqDfQgWAAgFgCQgGgCgQgBQgPgBgBgmQAAgoAEgHQADgIAOAEIALADIAQADQAJACAeAAQAegBAUADQgFAaABAYQAAAZgBAFQgBAFgWAAIgsAAgAAeAWIgGgsQgGgdAGgYQAUgDAegHQA6gOAbgBQAIAcgBAGIgBAJIACAFQAEARAAAOQABAHgBABQgCABADAFIh/AeIgGAAgAgPjhQgDgJgIgNQgJgOgPgfQgQgfAGgIQAHgJA3ghQA5ghAGgMQAFgMAOAOQAOAOAQAuIAYBKQAKAbiAAXQgVALgJAAQgFAAAAgEgAiCnDQgVgGgLgbQgHgOgCgNQgJgjAGglQADgXAOg6QAPg8AlAkQAlAkAVAbQAWAdADAOQALAogxAyQgoAqgYAAIgGgBg");
	this.shape.setTransform(-7.6,19);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTailStripes_007, new cjs.Rectangle(-25.3,-51.2,35.5,140.5), null);


(lib.TigerTailStripes_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ACjKqQgTgBgYgTQgXgUgWgtQgVgtgDgfQgDgfAFgDIAcAAQAcAAANgIIALgIIAJgIIAFgCQAJADARAqQASAqAIAhQALAngFAeQgEAVgKAGQgIAFgRAAIgDAAgAARFNQAYgHBVAQQADAKAIAMQAHAKgIAFQgJADhSAXQgagHgChBgAADDGQgHgmACgIQACgIAKAAIAJAAIANgBQAIgBAYgIQAXgIAQgCQABAaAEAYQAFAXAAAGQAAAFgSAGIgiALQgRAGgFgBQgFAAgMADIgCAAQgLAAgGgjgAgQANIgFgsQgDgdAEgYQAQgDAXgHQAugOAVgBQAGAcgBAGIgBAJIACAFQADARAAAOQAAAHgBABQgBABACAFIhjAeIgFAAgAg4jdIgOgcQgFgMgKgOQgHgKgBgMQAAgCAygmQAvgmANgfQAMggAKAqQAKApAFAcQALA1ABAXQACAZhkAQIgHACQgLAAgGgNgAiwmqQgUgEgGgbQgEgNABgNQgCghAMgoQAIgXAag9QAag+AfAgQAeAfAQAZQAQAaABAOQADAng8A6Qg0AzgXAAIgDAAg");
	this.shape.setTransform(0.5,14.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTailStripes_005, new cjs.Rectangle(-20.1,-53.5,41.3,136.4), null);


(lib.TigerTailStripes_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ADGKbQgegFgpgcQgpgcgSgaQgTgZADgGIAYgNQAYgOAIgOIAFgMIAEgLIADgFQAKgCAkAcQAkAbAYAZQAdAdAKAcQAIAUgGAKQgFAJgRAJQgLAGgQAAQgKAAgKgCgAghGWQAVgOBJgHQAEAKAIAJQAIAJgHAHQgHAGhEAtQgXAAgJhBgAhFEIQgHgmACgIQACgJAKAAIAIAAIANgBQAHAAAXgIQAVgJAOgCQACAaAEAYQAEAYAAAFQAAAGgQAFIggALQgQAGgEAAQgFgBgMADIgCABQgKAAgGgjgAhVBEIgEgtQgDgcADgYQAPgDAVgHQApgOASgBQAFAcAAAGIgBAJIABAFQADAQAAAOIAAAIQgCABACAFIhYAfIgFAAgAh7jDIgMgiQgEgPgJgRQgGgMAAgOQAAgDAvgjQAvgkANgiQANgiAHAxIALBRQAHA9AAAaQAAAdhdAEIgFAAQgLAAgFgQgAjymOQgVgDgEgbQgCgOACgNQAAgjAQgqQAKgZAhhCQAghDAfAgQAeAfAOAbQAOAaAAAPQAAAohDBAQg9A6gYAAIgDgBg");
	this.shape.setTransform(1.4,12.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTailStripes_003, new cjs.Rectangle(-25.5,-54.5,53.9,133.9), null);


(lib.TigerTailStripes_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AC0KJQgxgEgdgNQgdgNAAgGIAOgXQAOgZAAgPIgCgOIgCgLIABgGQAIgGAsAGQAtAGAhAJQAnAKAYATQAQAOAAAMQAAAKgKAQQgKARgdALQgVAHggAAIgZgBgAhYHLQAQgLA+gFQAFAHAHAIQAIAHgFAFQgFAFgzAlQgTAAgSg1gAiMEwQgGgmABgIQACgIAIAAIAHAAIALgBQAGgBASgIQASgIAMgCQABAaAEAYIADAdQAAAFgNAGIgbALQgNAGgEgBQgEAAgJADIgCAAQgIAAgFgjgAicBtIgEguQgDgcADgZQAMgDASgHQAjgNAQAAQAEAagBAHIAAAJIABAFQACAQAAAPIAAAIQgBABABAEIhLAfIgDABgAi9ifIgKggQgEgPgHgPQgGgLAAgOQAAgDApgrQApgrALgkQALgkAGAvIAKBPQAGA9AAAaQAAAchRATIgFACQgIAAgFgOgAkxl3QgCgOABgPQAAglAOgwQAIgcAchNQAchMAaAdQAZAcANAaQAMAZAAAQQAAArg5BQQg3BMgUAAQgRAAgEgcg");
	this.shape.setTransform(2.5,8.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTailStripes_001, new cjs.Rectangle(-28.2,-56.6,61.5,130.1), null);


(lib.TigerTailLoop2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.TigerTailLoop20001();
	this.instance.parent = this;
	this.instance.setTransform(-54.5,-190,0.5,0.5);

	this.instance_1 = new lib.TigerTailLoop20009();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-54.5,-190,0.5,0.5);

	this.instance_2 = new lib.TigerTailLoop20011();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-54.5,-190,0.5,0.5);

	this.instance_3 = new lib.TigerTailLoop20013();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-54.5,-190,0.5,0.5);

	this.instance_4 = new lib.TigerTailLoop20015();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-54.5,-190,0.5,0.5);

	this.instance_5 = new lib.TigerTailLoop20017();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-54.5,-190,0.5,0.5);

	this.instance_6 = new lib.TigerTailLoop20019();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-54.5,-190,0.5,0.5);

	this.instance_7 = new lib.TigerTailLoop20021();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-54.5,-190,0.5,0.5);

	this.instance_8 = new lib.TigerTailLoop20023();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-54.5,-190,0.5,0.5);

	this.instance_9 = new lib.TigerTailLoop20025();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-54.5,-190,0.5,0.5);

	this.instance_10 = new lib.TigerTailLoop20027();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-54.5,-190,0.5,0.5);

	this.instance_11 = new lib.TigerTailLoop20029();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-54.5,-190,0.5,0.5);

	this.instance_12 = new lib.TigerTailLoop20051();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-54.5,-190,0.5,0.5);

	this.instance_13 = new lib.TigerTailLoop20053();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-54.5,-190,0.5,0.5);

	this.instance_14 = new lib.TigerTailLoop20055();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-54.5,-190,0.5,0.5);

	this.instance_15 = new lib.TigerTailLoop20057();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-54.5,-190,0.5,0.5);

	this.instance_16 = new lib.TigerTailLoop20059();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-54.5,-190,0.5,0.5);

	this.instance_17 = new lib.TigerTailLoop20061();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-54.5,-190,0.5,0.5);

	this.instance_18 = new lib.TigerTailLoop20063();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-54.5,-190,0.5,0.5);

	this.instance_19 = new lib.TigerTailLoop20065();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-54.5,-190,0.5,0.5);

	this.instance_20 = new lib.TigerTailLoop20067();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-54.5,-190,0.5,0.5);

	this.instance_21 = new lib.TigerTailLoop20069();
	this.instance_21.parent = this;
	this.instance_21.setTransform(-54.5,-190,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},8).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_12}]},22).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_16}]},2).to({state:[{t:this.instance_17}]},2).to({state:[{t:this.instance_18}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_21}]},2).to({state:[{t:this.instance}]},2).wait(118));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-54.5,-190,185,300);


(lib.TigerTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerTail();
	this.instance.parent = this;
	this.instance.setTransform(-45.9,-76.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerTail_1, new cjs.Rectangle(-45.9,-76.9,102,166), null);


(lib.TigerStripesHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AAOD5QgOgIgGgTIgMgeQANAAADADIAFAGQANAIBGABIAFACQACABAAAGQAAAHgQAJIggAOgAAIBRIgBgBQgBAAAAgHIAkgOQAugTAmgYQAFgCAggiQARgSAhAHIABANQgBArgOAUQgbAohUABQgaAAg2gFgAhOABIgcgWQgRgSABgOQALgEAIACQALAFALAEQAtAPBzgHIABABQACABgBAHQAAAHgfAGIhXARgAhCh8QhbgGgKgJQgKgJgIgWIgPgmIgGgSIgDgIIgEgKIABgEIAAAAIABAAIABAAIAAABQAsAZA3AWQA2AXAiAGQAgAFAogKQAogLALgFQABAAAAAAQABAAAAAAQAAABAAAAQAAABAAAAQgfAkgOAJQgOAJgOAEQgOAFgoADg");
	this.shape.setTransform(-1.7,-10.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerStripesHindLegBack, new cjs.Rectangle(-23.1,-35.5,42.7,49.9), null);


(lib.TigerStripesFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AAFHgIgXgGQgJAEgXg1QgIgQgFgUQAvATALAFQAJAGAmAJQAlAJAbgOQAcgPA4AFQgXAGgOAHQgIAEgIAGQgKAGgUAQQgSAPgdAHQgOAEgNAAQgOAAgOgEgAAgE+IgBgBQgCgBAAgGQAAgLAwgNIBIgTQAXgGAKgrQABgsAygEQAFAEACACQABADAAAHQAAA8gNAWQgeA2hpAAgAh8D5QgNgBgZhNQAAgPAhgFQA9gJAygVQAJgDARgSQASgQAHgLQAWgfAjgfQAugoAlgMQAHgCACACQACABgDAJIgjAtQgmAzgPA4QgHAdgIAMQgQAZgkAJIgzALQgnAJgQAHQgHADgNAOQgKAJgMAAIgCAAgAhnAEIgBABQgCAAAAgGQAAgFAQgQQAZgaAXgeQAHgJA3giQA5giACgPQADgQA+g2QA+g3ALgOQAkAvAAAzQAAAgghAJQgoAHgNAHQgLAHgTAVQgVAZgHAFQgDADgsASQgqARgNAMQgNAOgiATQgnAVgRAAQgKAAADgCgAj2hZQgEgYgCgZQAAgYAYgRQAigVAWgRQALgIAngGQAqgHADgCIAtgWQAbgPACABIAAABIABADQAAAWgtAlQg1ApgVASIg1A/QgqAygMAAQgKAAgIgwgAi9kuQAAAAAAAAQgBgBAAAAQAAgBAAgBQAAAAAAgBQAAgLAfgoQAcglATgRQAqghAWAAQAWABArgoQAEAGAAAKQAAAOgVAiQgJAOgdALIgjAMQgSAMgvAkQgoAegIADgABclbQgDgCAAgHIAXgIQAWgHAtgpQAggjADAFQADAFAEAQQAGATAAAJQAAAIgSAMQgXAPgqAIQgZAGgOAAQgJAAgEgDg");
	this.shape.setTransform(-0.1,-10.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerStripesFrontLeg, new cjs.Rectangle(-25.4,-58.6,50.6,96.8), null);


(lib.TigerPaw = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhPAvQgHgMgBgOIAAgOQABgrAbgZQAYgXAjABQAkAAAYAVQAbAYAAAnQAAAdgPAWQgXAhgxAAQg9AAgSgmg");
	this.shape.setTransform(8.8,8.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerPaw, new cjs.Rectangle(0,0,17.5,16.9), null);


(lib.TigerNeck_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerNeck_wet();
	this.instance.parent = this;
	this.instance.setTransform(-32.5,-50.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerNeck_wet_1, new cjs.Rectangle(-32.5,-50.4,68,116), null);


(lib.TigerNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerNeck();
	this.instance.parent = this;
	this.instance.setTransform(-32.3,-50.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerNeck_1, new cjs.Rectangle(-32.3,-50.2,68,110), null);


(lib.TigerHead_roar_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerHead_roar_004();
	this.instance.parent = this;
	this.instance.setTransform(-51.5,-53.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerHead_roar_004_1, new cjs.Rectangle(-54.2,-58,121.7,117.3), null);


(lib.TigerHead_roar_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.TigerHead_roar_003();
	this.instance.parent = this;
	this.instance.setTransform(-51.3,-54.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerHead_roar_003_1, new cjs.Rectangle(-67.3,-65,135,128.6), null);


(lib.TigerHead_roar_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerHead_roar_002();
	this.instance.parent = this;
	this.instance.setTransform(-51,-53.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerHead_roar_002_1, new cjs.Rectangle(-52.8,-56.2,119.9,114.8), null);


(lib.TigerHead_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerHead_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-51.4,-51.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerHead_roar_001_1, new cjs.Rectangle(-52.8,-54.6,120.4,111.2), null);


(lib.TigerHead_004_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 2
	this.instance = new lib.TigerHead_004_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-44,-47.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.8,-48.6,103.9,105.2);


(lib.Tiger_blink_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgyADQAygKAzAKQg0gDgxADg");
	this.shape.setTransform(5.2,5.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FDA92D").s().p("AgkAgQgLgKgDgOIAAAAQAygEAzAEQgygJgzAJIgBgIQAAgSAPgNQAPgNAVgBQAVABAPANQAPANABASIgBAIIAAAAQgDAOgMAKQgPANgVAAQgVAAgPgNg");
	this.shape_1.setTransform(5.2,4.6);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyADQAygKAzAKQgzgDgyADg");
	this.shape_2.setTransform(18.3,4.9);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FDA92D").s().p("AgjAgQgNgLgCgOQAygEAzAEQgzgKgyAKQAAgZAPgNQAPgNAUgBQAWABAPANQAOANAAAZQgCAOgMALQgPANgWAAQgUAAgPgNg");
	this.shape_3.setTransform(18.3,4.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Tiger_blink_002, new cjs.Rectangle(0,0,23.4,9.1), null);


(lib.Tiger_blink_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDA92D").s().p("AgkAgQgLgKgDgOIAAAAQAvAPA2gPQgzgjgyAjIgBgIQAAgSAPgNQAPgNAVgBQAVABAPANQAPANABASIgBAIIAAAAQgDAOgMAKQgPANgVAAQgVAAgPgNg");
	this.shape.setTransform(5.2,4.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FDA92D").s().p("AgjAgQgNgLgCgOQAzAQAygQQgpgng8AnQAAgZAPgNQAPgNAUgBQAWABAPANQAOANAAAZQgCAOgMALQgPANgWAAQgUAAgPgNg");
	this.shape_1.setTransform(18.3,4.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Tiger_blink_001, new cjs.Rectangle(0,0,23.4,9.1), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.hindpawmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_loop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:120,glowclean:121,glowclean_loop:122,"final":123,"final_loop":124});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgLBzIg2gBQg+ACgfgzQgVgkAAgnIABgTIAOgIIABgCIADgBIABAAIAIgKIAQgVIABgFQAQgPAYAEQBIAKAxgZIABgCQAFgHADgHIAFgBIACACIAHAeIAKgGIArAAIAPAGIAIgFIABgCIAIgHIAsABIABAHQABAMgGAHIgEABQgNANgRAEIgWACIgCALQgEgBgDAEQgPAUgRAQIgGADQAvACAoANIADAFQAEABAAACIABAGQgCAOgGAIIgEADQgHATgSANIAcAEIAFAHIAAAGIABAAIgBAAIAAAAIgBAAIAAABIgMAFIgoADIANABIACADIgDAAQgTgEgVAAIgQAEQgQAFgQAAQgcAAgRgFg");
	this.shape.setTransform(18,67.6);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(25,67.3,0.499,0.499,0,159.7,-20.3,50.6,5.1);

	this.instance_1 = new lib.tiger_pawGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-93.7,62.6,1.6,1.65,0,0,0,68.3,26.7);

	this.glow = new lib.blueglowpaws();
	this.glow.parent = this;
	this.glow.setTransform(-93.7,62.6,1.6,1.65,0,0,0,68.3,26.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance}]},6).to({state:[{t:this.instance}]},108).to({state:[{t:this.instance},{t:this.glow}]},1).to({state:[{t:this.instance}]},2).to({state:[]},2).to({state:[]},101).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,55.6,36,24);


(lib.hindpawbackmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":222,"final_loop":223});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AiRB0QgiAAgZgOIABgDIAJgDQAagHAXgNQAFgCAEgEQAJgGAKgEIAKgTIAAgIQAHgTAAgXQACgEAFgEIAHgGIAGAAIABgCIAHgEIABAAQAAgFgCgEIgGgIIgBgUIAMgFIATAAIgBABIADgBIgCAAIAEgEIAEACIgCADIADgDIAFACIABAAIACgCIADgBQAAAAAAgBQABAAAAAAQABAAAAgBQAAAAABgBIAAgDQAHgBAIACIADABIAHALQAIALAIAOIACADIAKACQAGgmANgkIABgBQAAgBABAAQAAgBABAAQAAgBABAAQAAAAABABIAAgBQAgAEAYAZIAAABIAHAEIANgSIAQAAQATAKgBAWQgBAFgCAEIgZALIgDACIABAcIAEAGIAKACQARgOAUgKIAGgBIAEgEQAEgFAGAAIADAQQgGAQgMALIgBABIgEABQgIAMgDANQgmAhgsAUIgEABQgPAHgOAHIgFACIgLACIgEACQgyAQg6gCQgPgCgLADg");
	this.shape.setTransform(26.1,67.5);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(25.6,70.3,0.499,0.499,170.4,0,0,50.5,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},44).to({state:[]},172).to({state:[]},1).wait(79));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(5.6,55.9,40.9,23.3);


(lib.hindlegmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":84,"glowclean":85,"glowclean_loop":86,"final":87,"final_loop":88});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("ACfFoQgLgKgHgNQgLgYgIgHQgQgNgfgBIABgKIgEgJIgFgEIAAgCIgDgDQgBgBAAAAQAAgBAAgBQgBAAAAAAQAAgBAAAAIgCAAQgWgkgZglQgegugdgyIgBAEQgDgJgHgNQgJgOgIgJIgBgFQgTgUgPgYQgdgygrgqQgmgmgWgvIgEgDQgBgGgDgFQgMgVgJgRIgFgIIgEgDIgCgCIgBgDIgDAAIgBAAIgCAAQAJg9AoApQAbhmBGAlQALAEAHABQAWAAAbgWQArgjAlAAQAUAAASAKQAcAOANACQAZANABAMQAlgZATAWQASAWgiBJQgJAPgBAYQgBAYAUAeIAfgHIAEgCIgBAKIgDAFQAABhASBXIABAFIAQAgIAIAmIAFAIQAHAlANAlIABAAQADAMAGANQACADAFACIAAAIIALAPQADAeAAATQAAAogCAFQgJAhgrAAQgyAAgagWg");
	this.shape.setTransform(38.2,97.6);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(30.2,86.7,1,1,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(42.7,96,1,1,0,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(43.2,84.9,0.673,0.673,15,0,0,35.9,10.9);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.1,102.7,0.673,0.673,61.7,0,0,35.9,11.2);

	this.instance_4 = new lib.tiger_legGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-52.7,83.1,1.649,1.649,2.3,0,0,-33.9,50.3);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(-52.7,83.1,1.649,1.649,2.3,0,0,-33.9,50.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_4}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},72).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},139).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(9.4,59.4,57.7,76.4);


(lib.hindlegbackmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":221,"final_loop":222});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AiCDIQgSgSgKgRQgMgTgCgSQgEgegegsIgBgDQgVAAgSgKIAugXIANgQIBCgrIAHgLQAlgRAZgfIAsgjIACgIIAOgNIAUgeIAYgZIAKgUIAJgHIACgIQAMAJAAAIQAlgaATAXQASAWgiBJQgJAOgBAZQgBAYAUAeIAfgHQBfg0gPDHQhpAHhlAzQgPAIgLAMIgOAHIgFAIQgyAWgfAkQgOgUgdgbg");
	this.shape.setTransform(40.7,87.5);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(42.7,90,0.5,0.5,90,0,0,47.8,9.4);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(38.1,96.2,0.5,0.5,90,0,0,48.9,4.9);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(43.6,96.5,0.337,0.337,105,0,0,36,11);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(34.8,94.5,0.337,0.337,151.7,0,0,36,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},44).to({state:[]},171).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(16.1,62.8,49.4,49.4);


(lib.frontpawbackmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":222,"final_loop":223});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAJBhIg1gBQgbABgVgKQgbgMgSgdQgGgKgEgLQAKgDAIgEIACgDIAKgCQgDgHgBgHQgCggAPgbQgIgCAAgIQgCgpApANIAEAMQAHASgCAVIADABIACABIADACIABAAIAHALQAPASAMAVIABgVQABgpAcgZIAIAAQAZACAMAYQAGACACAHQAEAMAJACIABgXIAKgKIAUACQAEAGAFADQAIAFADALQAKApgrAEIACARIAFAEIABADIABADIABABIABAAQAEgGgBgLIABgFIAIgFQALgCAIAEIAJAEIAHAOIAAABQADAigJAgQgSgDgTAAIgGABIgLADQgPAFgRAAQgcAAgSgFg");
	this.shape.setTransform(15.9,69.4);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(22.4,71.1,0.499,0.499,170.3,0,0,50.5,4.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},44).to({state:[]},172).to({state:[]},1).wait(79));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.1,59.3,29.6,20.3);


(lib.frontlegbackmud = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":221,"final_loop":222});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("ACiFjQgLgJgHgOQgLgYgIgHQgRgOgjAAQhUAAgXg3QgNgdgBgrQgKgXgsgrQgRgRgLgRQgMgTgCgSQgEgdgegtIgBgCQhUgBgbiTQgDgVAGAAQAEhfAwAwQAahmBGAlQAMAFAGAAQAWABAbgWQAVgRAUgJQgNAKgLALIgBAEIgCAEQgCADgDAAIAAAFIgEAFQgDAHAAAIQAAAEgBAEIADAGIgBABQAAABAAAAQAAAAAAABQAAABAAAAQAAABAAABQAAAAAAABQAAAAAAABQAAAAgBAAQAAABAAAAIAAABQADAMABAOQgEASAEAVQAFAcANAZQANAaAUAVQATAWAWATIAfAcQAfAeApASQASATAVARQAdAXAcAaQAWAWAZATIAIA/QAMBVAAAmQAAApgCAEQgJAhgrAAQgyAAgagWgAg/kYIABAAIgBABg");
	this.shape.setTransform(37.9,98);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(30.2,86.7,1,1,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(42.7,96,1,1,0,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(43.2,84.9,0.673,0.673,15,0,0,35.9,10.9);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.1,102.7,0.673,0.673,61.7,0,0,35.9,11.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},45).to({state:[]},170).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(8.8,60.4,58.4,75.4);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.TigerTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-50,-11,1.051,1.051,0,131.5,131.4,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-78.2,-30.6,1.051,1.051,0,131.5,131.4,35.5,10.9);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-15.6,-22.4,1.051,1.051,0,131.5,131.4,35.6,10.9);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(15.8,1.1,1.051,1.051,0,6,6,35.6,11.1);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(47.7,-25.7,1.051,1.051,0,-178.7,-178.8,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.TigerTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_stop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":90,"glowclean":91,"glowclean_loop":92,"final":93,"final_loop":94});

	// Layer 3
	this.instance = new lib.TigerTorso0001();
	this.instance.parent = this;
	this.instance.setTransform(-146.4,-46.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(37.5,-19.5,1,1,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(5.4,-20.3,1,1,0,0,0,47.6,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-32.2,-12.6,1,1,0,0,0,50.6,5.2);

	this.instance_4 = new lib.TigerTorso0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-146.4,-46.9,0.5,0.5);

	this.instance_5 = new lib.tiger_backGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-8.6,-7.1,1.946,1.946,0,0,0,52.1,18.4);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-8.6,-7.1,1.946,1.946,0,0,0,52.1,18.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},78).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(151));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-146.4,-47,265,141.1);


(lib.TigerTail_loop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerTail_loop0001();
	this.instance.parent = this;
	this.instance.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_1 = new lib.TigerTail_loop0003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_2 = new lib.TigerTail_loop0005();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_3 = new lib.TigerTail_loop0007();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_4 = new lib.TigerTail_loop0009();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_5 = new lib.TigerTail_loop0011();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_6 = new lib.TigerTail_loop0013();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_7 = new lib.TigerTail_loop0015();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-45.9,-77.4,0.5,0.5);

	this.instance_8 = new lib.TigerTail_loop0017();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-45.9,-77.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).wait(2));

	// Stripes
	this.instance_9 = new lib.TigerTailStripes_001();
	this.instance_9.parent = this;
	this.instance_9.setTransform(11.1,3.1);
	this.instance_9.shadow = new cjs.Shadow("#000000",1,1,3);

	this.instance_10 = new lib.TigerTailStripes_003();
	this.instance_10.parent = this;
	this.instance_10.setTransform(11.1,3.1);
	this.instance_10.shadow = new cjs.Shadow("#000000",1,1,3);

	this.instance_11 = new lib.TigerTailStripes_005();
	this.instance_11.parent = this;
	this.instance_11.setTransform(11.1,3.1);
	this.instance_11.shadow = new cjs.Shadow("#000000",1,1,3);

	this.instance_12 = new lib.TigerTailStripes_007();
	this.instance_12.parent = this;
	this.instance_12.setTransform(20.6,-0.3);
	this.instance_12.shadow = new cjs.Shadow("#000000",1,1,3);

	this.instance_13 = new lib.TigerTailStripes_009();
	this.instance_13.parent = this;
	this.instance_13.setTransform(25.5,0.1);
	this.instance_13.shadow = new cjs.Shadow("#000000",1,1,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9}]}).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_12}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_12}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_9}]},2).wait(2));

	// Tail
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDA92D").s().p("ACIK8QglgdgZgtQgagtgGgPIgOgiQgJgUgIgfQgLgdgEgeQgLhFgEhoQgGiagCgSIgHhDIgQg3QgPgzgNgbQgOgbg6hJQg1hCAAgVQgOgYgCgIQgEgOgQgZQgPgWgNgOQgrgugVggQgbgngJgkQgHgeggg9Qgdg5AAgCQAAgXARgEQAXgFAsAjQAKAGAvAWQAvAYAIADQAGACAJAHQAaAEAgAVQB6BOA0C8QASBGALBsQAFA+AKB9QAFA4AEB/QAHBzAFAyQAEAxAPBAQAPBBAZAiQAZAjAqAUQAqAUA/AMQBOAOANAFQApANAAAbQAAAQgIAIQgSAQg2AAQigAAg8gxg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FDA92D").s().p("AFCL7IgRgBQgagCgTgGQgPgMg6hMQg7hLgDgXIgDgcQgEgQgGgTQgGgWgGgfQgIgdgDgeIgGhAIgJhxQgEhEgFgvQgDgtgEgPIgMhCQgEgLgOgsIgPgoQgJgWgHgQQgUgig2hCIgqg0QgQgVgDgMIgUgeQgHgNgSgWQgQgUgPgOIgrgnIgWgWIgJgJQgNgPgJgOQgMgUgHgWIgEgMQgKgcgcgzIgDgFQgcg1AAgDQAAgVAQgFIACAAQAMgDAVAKQALAFAOAJIALAHIA5AbIAzAYIAFACQAHADAJAGQAWAFAZAOIAMAHQBXA1A8BhQAdAtAXA3QAUAxAQBAQAHAcAGAeQAQA/AOBrIACAQQAKBAAHB2IACAiIAJCHQADAmAGAsIAFAhQAKBAAQAoQALAYAQAUIAjAuQAaAiAfASQAeARAhArIgCAEQgCAGgFAEQgRAPgrAAIgMAAg");
	this.shape_1.setTransform(-3.3,1.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FDA92D").s().p("AEfMIIgCgEQhBi3gKgjQgKgkgBgGQgBgQgEgTIgHg2IgGg8IgFhCIgJhyQgGhCgIgzQgFgpgGgVIgQhCIgUg2IgRgoQgKgVgKgRQgYgogyg8IgugzIgZgfQgOgTgJgJIgdggQgSgRgRgNIgwgkIgYgTIgKgJQgRgNgJgMQgOgSgIgXIgEgMQgLgcgfg0IgCgFQgeg1AAgDQABgWAQgFIABAAQANgDAVALIAaAMIAMAHIA6AaIAzAXIAGACIAQAIQAXAIAZAOIAMAGQBaA0BGBYQAjArAdA0QAcAvAWA8QALAbAJAdQAaBDASBkIADAQQARBKAJBuQABARgDA7QgDA6AHApQAIApAEAcIAGAsQAFA/AHAuQAFAaAIAXIAJAZQAcB7ANAwIgFAHQgDAGgFAEQgSAPglAAIgRgBg");
	this.shape_2.setTransform(-6.4,2.9);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FDA92D").s().p("ADdMWIgRgDQhGgPBEhNIAdg1QAPgdACgqQABgqgBgTIgBgZIAAgjIgBg4IgCg9IgDhDQgEg4gHg8QgHg/gLg4QgHgkgIgaQgJghgLgiIgWg1IgUgpQgKgUgLgSQgegugwg1QgZgcgXgXIgegeIgcgZIgggcQgTgPgUgNQgbgRgZgPIgcgRIgLgHQgUgMgJgKQgPgPgJgZIgFgMQgMgbghg2IgDgFQgfg1ABgEQABgVAPgFIACAAQAMgDAVAKIAcAMIANAGIA7AYIA0AXIAGACIAQAIQAYAJAYAOIANAHQBcAyBQBQQAqApAjAvQAjAuAdA3QAPAbAMAbQAkBJAXBdIAEAQQAXBTAKBlIAEAjQAGBOACA/IADBUIAAAiQAAA+gCA0IABA9QAAAigTA5QgUA5gBAaQgCAagsA2QgPAIgWAAQgLAAgNgCg");
	this.shape_3.setTransform(-6.6,4.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FDA92D").s().p("ABkMfQhCgUBthhQBfhWARh7QARh3gFh3QgGh4gdh3Qgeh3g7hpQg9hqhehRQhehQhsgxIgggPQgggOgMgKQgTgQgNgjQgNgdgmg6Qghg2ABgEQACgVAPgFQANgDAXALIAcAKQBaAjAlAPQAkAQAjATQBoAzBfBNQBhBNBGBkQBGBjAlB0QAmB1AMB3QAMB4gEBuQgFBugaBmQgaBmg6BWQgMARgKAMQgdAiglAjQgXAZgkAAQgUAAgXgIg");
	this.shape_4.setTransform(-2.9,5.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape_2}]},2).to({state:[{t:this.shape_3}]},2).to({state:[{t:this.shape_4}]},2).to({state:[{t:this.shape_3}]},2).to({state:[{t:this.shape_2}]},2).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.9,-77.4,102,178);


(lib.TigerPaws = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.TigerPaw();
	this.instance.parent = this;
	this.instance.setTransform(32.1,12.3,1.34,1.34,0,0,0,8.8,8.4);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.instance_1 = new lib.TigerPaw();
	this.instance_1.parent = this;
	this.instance_1.setTransform(20.4,12.4,1.34,1.34,0,0,0,8.8,8.5);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.instance_2 = new lib.TigerPaw();
	this.instance_2.parent = this;
	this.instance_2.setTransform(11.8,11.6,1.34,1.34,0,0,0,8.8,8.4);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerPaws, new cjs.Rectangle(-6,-5.6,59.3,38.7), null);


(lib.TigerHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 3
	this.backfootbackmud = new lib.hindpawbackmud();
	this.backfootbackmud.parent = this;
	this.backfootbackmud.setTransform(-4.3,68,1,1,0,0,0,30.2,54.7);

	this.hindlegbackmud = new lib.hindlegbackmud();
	this.hindlegbackmud.parent = this;
	this.hindlegbackmud.setTransform(13.6,35,1,1,-68.4,0,0,37.9,97.5);

	this.instance = new lib.TigerHindLegBack0004();
	this.instance.parent = this;
	this.instance.setTransform(-38.5,-92.9,0.5,0.5);

	this.instance_1 = new lib.TigerHindLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-38.5,-92.9,0.5,0.5);

	this.instance_2 = new lib.TigerHindLegBack0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-38.5,-92.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.hindlegbackmud},{t:this.backfootbackmud}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-52.3,-92.9,89.7,207.9);


(lib.TigerHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-192.4,49.7,0.69,0.69,0,-75.8,-75.9,35.8,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-199.9,21.5,0.69,0.69,0,-75.8,-75.9,35.8,11.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-169.5,23.3,0.69,0.69,0,-75.8,-75.9,35.7,11.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(18.3,-20.1,0.69,0.69,0,-75.8,-75.9,35.8,11.2);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(3.4,10.4,0.69,0.69,0,-75.8,-75.9,35.8,11.3);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-12.6,-17.3,0.69,0.69,0,-75.8,-75.9,36,11.2);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(2.7,-27.3,0.69,0.69,0,-75.8,-75.9,35.8,11.3);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(18.7,45.1,0.69,0.69,0,-75.8,-75.9,35.8,11.7);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-17,28,0.69,0.69,0,-75.8,-75.9,35.8,11);

	this.instance_9 = new lib.Bubbles_together();
	this.instance_9.parent = this;
	this.instance_9.setTransform(2,-21.6,0.69,0.69,0,36.7,36.6,35.5,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.TigerHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 3
	this.backfootmud = new lib.hindpawmud();
	this.backfootmud.parent = this;
	this.backfootmud.setTransform(23.5,70.4,1,1,0,0,0,30.2,54.7);

	this.hindlegmud = new lib.hindlegmud();
	this.hindlegmud.parent = this;
	this.hindlegmud.setTransform(-1,4.2,1,1,0,0,0,37.9,97.5);

	this.instance = new lib.TigerHindLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-40.5,-97.4,0.5,0.5);

	this.instance_1 = new lib.TigerHindLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-40.5,-97.4,0.5,0.5);

	this.instance_2 = new lib.TigerHindLeg0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-40.5,-97.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.hindlegmud},{t:this.backfootmud}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-40.5,-97.4,85,206);


(lib.TigerHead_004_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Tiger Cheek_bubbles
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-15.4,16,0.522,0.522,0,36.7,36.6,35.6,11);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},59).wait(44));

	// Tiger Cheek_bubbles
	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1,36.2,0.522,0.522,0,36.7,36.6,35.6,11);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({_off:false},0).to({_off:true},59).wait(44));

	// TigerLower Jaw_bubbles
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(8.8,13.5,0.522,0.522,0,-75.8,-75.9,35.4,11.1);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(26.7,14.1,0.522,0.522,0,36.7,36.6,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.TigerHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 2
	this.instance = new lib.TigerHead_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-45.4,-47.4,0.5,0.5);

	this.instance_1 = new lib.TigerHead_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.4,-47.4,0.5,0.5);

	this.instance_2 = new lib.tiger_mouthGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0.5,21.2,1.62,1.62,0,0,0,16.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(0.5,21.2,1.62,1.62,0,0,0,16.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},54).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(141));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47,-48.6,104.6,104.2);


(lib.TigerFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 3
	this.frontfootbackmud = new lib.frontpawbackmud();
	this.frontfootbackmud.parent = this;
	this.frontfootbackmud.setTransform(-7.8,55.3,1,1,0,0,0,30.2,54.7);

	this.frontlegbackmud = new lib.frontlegbackmud();
	this.frontlegbackmud.parent = this;
	this.frontlegbackmud.setTransform(3.4,25.7,1,1,-150,0,0,37.9,97.5);

	this.instance = new lib.TigerFrontLegBack0004();
	this.instance.parent = this;
	this.instance.setTransform(-42.5,-84.4,0.5,0.5);

	this.instance_1 = new lib.TigerFrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42.5,-84.4,0.5,0.5);

	this.instance_2 = new lib.TigerFrontLegBack0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42.5,-84.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.frontlegbackmud},{t:this.frontfootbackmud}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-71,-84.4,118.7,193.8);


(lib.TigerFrontLeg_roar_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.TigerStripesFrontLeg();
	this.instance.parent = this;
	this.instance.setTransform(-0.8,-11.6);
	this.instance.shadow = new cjs.Shadow("#000000",1,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 3
	this.instance_1 = new lib.TigerPaws();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-16.1,69.7,1,1,0,0,0,21.9,11.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Leg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDB102").s().p("AjAMhQgOgGgFgSIgCgeQAAgbAlgcQAigaAvgNQAggIAZAAQgmgFhfABQhgABCthMQCshLislwQiulvAIh2QAIh2A0h5QA0h6BMgwQBMgzBIAUQBQAXAwBoQAfCAARCQQASCRgRBTQgSBSgTDyQgTD0AFBtIAAA4QAEAkhbB+Qg5A4hvAdIh4ADQgMgCgHgFg");
	this.shape.setTransform(-0.2,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerFrontLeg_roar_001, new cjs.Rectangle(-44,-80.8,75.8,172.6), null);


(lib.TigerFrontLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":70});

	// tiger_pawMud_001_bubbles
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(196.5,63.4,1.051,1.051,0,177.4,177.3,35.6,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(141,59.9,1.051,1.051,0,35.4,35.3,35.5,11.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1.3,59,1.051,1.051,0,131.5,131.4,35.6,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-40.3,52.7,1.051,1.051,0,131.5,131.4,35.4,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},69).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.water_drops_016 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,-3.5,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(117.9,-21.9,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,-32.6,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(150.9,-21.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(85.9,-3.5,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(237,42.7,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,4.6,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,-5.3,18,23);


(lib.tiger_pawMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":222,"final_loop":223});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AiGD0Ig2gBQg+ABgfgzQgVgjAAgoQAAgcAGgVIACAAIAdgcQApglA9gBIgEADIADAAQAAAAABAAQAAAAABgBQAAAAAAgBQABAAAAgBIABgCIAFABIAZAIIAmAAQBXgJAagiIAFAAQACgFAEgCQAOgGAFgOQABAAAAAAQABAAAAAAQABgBAAAAQAAgBAAgBQAEgPAJgOIACgSQAHgKABgPQACgdgCgcIADAAIgDgCIgCgdIACAAIgCgTIgDgEQAHgEANAFQAbAKAAAdIAAAKQgCAIgHACQAPAIAMASQAMARALAZIAFgrQADgbAKgQQASgeAeAgQARASANAZIgBgMQAAgVAQgJQAPgJAAATQAAAEAJAJQAIAIAAAKQAAAHgEAFQgGAMgRAAQgHAAgFgEQAJAWAGAcIABAAIAEgNQAGgWAJgFQgHAHgDAIIACgDQAEA8gMA3IgCADIAAAIQgdBHgsA7IgHALIgpAqQgQAHgJAMIgBABIgBAAIgBABQguAjgbAAQgoAAgTgDQgSgEgVAAIgRAEQgPAFgRAAQgcAAgSgFg");
	this.shape.setTransform(30.3,54.7);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(35.2,64.7,0.499,0.499,140.4,0,0,50.6,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},44).to({state:[]},172).to({state:[]},1).wait(79));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,29.8,60.6,49.8);


(lib.tiger_mouthMud_002_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(8.8,13.5,0.522,0.522,0,-75.8,-75.9,35.4,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(26.7,14.1,0.522,0.522,0,36.7,36.6,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.tiger_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":221,"final_loop":222});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("ADJDRIABgBIAAABIAAAAIgBAAgAAzDOQgeAAgdACQgMgNgRgQQgSgRgKgRQgMgTgDgTQgDgegegsIgBgCQg5gBgehCQAHgHAMgHQALgGAOgGIAFgGQAIgCAJgEQAKgFAAgIIAlgXIAGgHQAFgBAFgCQAjgVAkgRQAEgHAFgDQAhgUAjgJIAPgLQALAqAaAnQAkA1AGBEQADAdgMAWIANAzQAQA3AIA6QhJgDhKAAg");
	this.shape.setTransform(31.5,89.6);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(30.2,86.7,1,1,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(42.7,96,1,1,0,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(43.2,84.9,0.673,0.673,15,0,0,35.9,10.9);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.1,102.7,0.673,0.673,61.7,0,0,35.9,11.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},44).to({state:[]},171).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(11.3,68.7,40.5,41.8);


(lib.TigerHindLegBackcopy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhdMPIgYAAQgNAEgRAAQgbAAgTgHQgKACgNAAQhCAAgTgnQgHgNgBgQIAAgOQAAgvAdgbQAagYAmABQAXAAASAIQANgEAPAAQARAAAOAFQAagIAZgZIAKgKQAdgdAignQATgXAAgoQAAh0gqhsQgOgmhPiYQhAh6gehqQgqiYAAjAQgHiAAVhuIIQAAQAKAyABA+QABAwgDBEQAAD2goDWQgKA2gSBQQgMA9AAAfQAAAWAcBtIAcBqQAAAYgnBEQgnBFg7B9QgTAogcAcIgCACQgoAmg5APQgWANghAAQgVAAgRgEg");
	mask.setTransform(-2.4,12.4);

	// Layer 5
	this.instance = new lib.tiger_pawMud_001();
	this.instance.parent = this;
	this.instance.setTransform(-21.6,75.1,1,1,0,0,0,30.7,39.8);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Paws
	this.instance_1 = new lib.TigerPaws();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-15.9,81.7,0.794,0.794,0,0,0,21.9,11.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer 2
	this.instance_2 = new lib.TigerStripesHindLegBack();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1.4,30.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Layer 3 (mask)
	var mask_1 = new cjs.Shape();
	mask_1._off = true;
	mask_1.graphics.p("AkOL3QgOgPAAglQAAhPBFgIQASgCAogBQAigDAighQAhghApgtQASgXAAgoQAAh0gqhsQgOgmhPiYQhAh6gehqQgqiYAAjAQgHiAAVhuIIQAAQAKAyABA+QABAwgDBEQAAD2goDWQgKA2gSBQQgMA9AAAfQAAAWAcBtIAcBqQAAAYgnBEQgnBFg7B9Qg7B9iWAGIguABQhvAAgagag");
	mask_1.setTransform(0,12.2);

	// tiger_legMud_001
	this.instance_3 = new lib.tiger_legMud_001();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-21.4,26.9,1,1,-73,0,0,33.3,59.3);

	var maskedShapeInstanceList = [this.instance_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E69223").s().p("AkOL3QgLgLgDgZIAAgQQAAhPBFgIQASgCAogBQAigDAighIAKgKQAdgdAjgnQASgXAAgoQAAh0gqhsQgOgmhPiYQhAh6gehqQgqiYAAjAQgHiAAVhuIIQAAQAKAyABA+QABAwgDBEQAAD2goDWQgKA2gSBQQgMA9AAAfQAAAWAcBtIAcBqQAAAYgnBEQgnBFg7B9QgTAogcAcIgDACQg7A5hkAEIguABQhvAAgagag");
	this.shape.setTransform(0,12.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TigerHindLegBackcopy, new cjs.Rectangle(-39.3,-66.3,67.9,167.5), null);


(lib.TigerHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"glowclean_loop":102,"final":103,"final_loop":104});

	// Layer 5
	this.instance = new lib.tiger_mouthMud_002_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-16.5,8.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},94).wait(59));

	// Layer 2
	this.instance_1 = new lib.TigerHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-51.3,-51.3,0.5,0.5);

	this.instance_2 = new lib.TigerHead_0030002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-51.3,-51.3,0.5,0.5);

	this.instance_3 = new lib.tiger_mouthGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-30,20.4,1.25,1.5,0,0,0,16.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(-30.5,18.1,1.62,1.62,0,0,0,16.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},95).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},52).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-53.1,-54.6,120.8,109.3);


(lib.TigerHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"glowclean_loop":102,"final":103,"final_loop":104});

	// Layer 5
	this.instance = new lib.tiger_mouthMud_002_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-16.5,8.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},94).wait(59));

	// Layer 2
	this.instance_1 = new lib.TigerHead_0020001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-46.9,-46.4,0.5,0.5);

	this.instance_2 = new lib.TigerHead_0020002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-46.9,-46.4,0.5,0.5);

	this.instance_3 = new lib.tiger_mouthGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-22.3,20.5,1.5,1.5,0,0,0,16.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(-20.4,22.1,1.62,1.62,0,0,0,16.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},95).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},52).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.6,-47.7,109.7,105.3);


(lib.TigerHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"glowclean_loop":102,"final":103,"final_loop":104});

	// Layer 5
	this.instance = new lib.tiger_mouthMud_002_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-16.5,8.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},94).wait(59));

	// Layer 2
	this.instance_1 = new lib.TigerHead_0010001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.4,-48.4,0.5,0.5);

	this.instance_2 = new lib.TigerHead_0010002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-45.4,-48.4,0.5,0.5);

	this.instance_3 = new lib.tiger_mouthGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0,17,1.5,1.5,0,0,0,16.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(0.5,21.2,1.62,1.62,0,0,0,16.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},95).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},52).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47,-49.1,108.6,103.7);


(lib.TigerFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 5
	this.frontfootmud = new lib.tiger_pawMud_001();
	this.frontfootmud.parent = this;
	this.frontfootmud.setTransform(-7.4,59.9,1,1,0,0,0,31.7,56.6);

	this.frontlegmud = new lib.tiger_legMud_001();
	this.frontlegmud.parent = this;
	this.frontlegmud.setTransform(11,1.4,1,1,-83.5,0,0,37.9,97.5);

	this.instance = new lib.TigerFrontLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-42,-83.4,0.5,0.5);

	this.instance_1 = new lib.TigerFrontLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42,-83.4,0.5,0.5);

	this.instance_2 = new lib.TigerFrontLeg0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42,-83.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.frontlegmud},{t:this.frontfootmud}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-44,-83.4,83,179);


(lib.Tiger = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rest:0,rest_stop:243,wrongAnswer:245,"clean":295,clean_stop:313,wet:315,wet_stop:339,excited:341,excited_stop:405,animalSound:455});

	// timeline functions:
	this.frame_243 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_293 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_313 = function() {
		/* stop();*/
	}
	this.frame_339 = function() {
		/* stop();*/
	}
	this.frame_451 = function() {
		/* 
		
		gameObjects._game.done();
		
		stop();*/
	}
	this.frame_494 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(243).call(this.frame_243).wait(50).call(this.frame_293).wait(20).call(this.frame_313).wait(26).call(this.frame_339).wait(112).call(this.frame_451).wait(43).call(this.frame_494).wait(1));

	// Layer 4
	this.legs_bubbles = new lib.TigerHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(237.7,178,0.468,0.468,0,0,0,-14.3,-58.7);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).to({_off:true},315).wait(180));

	// Tiger Head_004
	this.mouth_bubbles = new lib.TigerHead_004_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(152.6,171.2,0.515,0.515,0,0,0,33.3,28.2);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).to({_off:true},315).wait(180));

	// Tiger Front Leg
	this.paws_bubbles = new lib.TigerFrontLeg_bubbles();
	this.paws_bubbles.parent = this;
	this.paws_bubbles.setTransform(161.8,182.7,0.468,0.468,0,0,0,2.9,-61.6);

	this.timeline.addTween(cjs.Tween.get(this.paws_bubbles).to({_off:true},315).wait(180));

	// Tiger Torso
	this.back_bubbles = new lib.TigerTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(179.2,173.1,0.468,0.468,0,0,0,-51.5,0);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},315).wait(180));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(178.4,204.9,0.75,0.75);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(412).to({_off:false},0).to({_off:true},43).wait(40));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(270,195.2,0.75,0.75);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(427).to({_off:false},0).to({_off:true},28).wait(40));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(238.4,165.1,0.75,0.75);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(419).to({_off:false},0).to({_off:true},36).wait(40));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(217.4,195.2,0.75,0.75);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(433).to({_off:false},0).to({_off:true},22).wait(40));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-376.9,-129.4,0.75,0.75);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(405).to({_off:false},0).to({_off:true},50).wait(40));

	// Tiger Front Leg
	this.instance_5 = new lib.TigerFrontLeg_roar_001();
	this.instance_5.parent = this;
	this.instance_5.setTransform(159.2,248.6,0.468,0.468,0,0,0,-2.6,79.3);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(341).to({_off:false},0).wait(12).to({scaleY:0.48},0).wait(2).to({scaleY:0.47},0).wait(2).to({regX:-2.5,regY:79.4,scaleY:0.46,skewX:2.8,x:159.3},0).wait(2).to({regX:-2.4,scaleY:0.45,skewX:5.8},0).wait(2).to({scaleY:0.44,y:248.7},0).wait(2).to({regY:79.5,scaleY:0.43,skewX:6.1},0).wait(2).to({scaleY:0.45,skewX:3,x:159.4,y:248.9},0).wait(2).to({regX:-6,regY:81.5,scaleY:0.47,skewX:0,x:157.6,y:249.6},0).wait(2).to({regX:-6.2,scaleY:0.48,x:157.4,y:250.1},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,skewX:-0.3,x:160.6,y:249.6},0).wait(2).to({regX:-0.1,scaleY:0.49,x:160.4},0).wait(2).to({regX:-6.9,regY:81.5,scaleY:0.5,skewX:-0.5,x:157.6,y:249.7},0).wait(18).to({regX:-7,scaleY:0.49,skewX:-0.3,x:157.2,y:249.6},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,x:160.6},0).wait(2).to({regX:-0.1,regY:81.5,scaleY:0.48,skewX:0,x:160.2,y:249.9},0).wait(2).to({regX:-6,scaleY:0.47,x:157.6,y:249.4},0).wait(56).to({regX:-2.6,regY:79.3,x:159.2,y:248.6},0).wait(1).to({scaleY:0.48},0).wait(1).to({scaleY:0.47},0).wait(1).to({regX:-2.5,regY:79.4,scaleY:0.46,skewX:2.8,x:159.3},0).wait(2).to({regX:-2.4,scaleY:0.45,skewX:5.8},0).wait(2).to({scaleY:0.44,y:248.7},0).wait(2).to({regY:79.5,scaleY:0.43,skewX:6.1},0).wait(2).to({scaleY:0.45,skewX:3,x:159.4,y:248.9},0).wait(2).to({regX:-6,regY:81.5,scaleY:0.47,skewX:0,x:157.6,y:249.6},0).wait(2).to({regX:-6.2,scaleY:0.48,x:157.4,y:250.1},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,skewX:-0.3,x:160.6,y:249.6},0).wait(2).to({regX:-0.1,scaleY:0.49,x:160.4},0).wait(2).to({regX:-6.9,regY:81.5,scaleY:0.5,skewX:-0.5,x:157.6,y:249.7},0).wait(12).to({regX:-7,scaleY:0.49,skewX:-0.3,x:157.2,y:249.6},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,x:160.6},0).wait(2).to({regX:-0.1,regY:81.5,scaleY:0.48,skewX:0,x:160.2,y:249.9},0).wait(2).to({regX:-6,scaleY:0.47,x:157.6,y:249.4},0).wait(1));

	// Tiger Head
	this.tiger_head = new lib.TigerHead_004();
	this.tiger_head.parent = this;
	this.tiger_head.setTransform(152.6,171.2,0.515,0.515,0,0,0,33.3,28.2);

	this.tiger_head_1 = new lib.TigerHead_001();
	this.tiger_head_1.parent = this;
	this.tiger_head_1.setTransform(147.4,171.2,0.515,0.515,0,0,0,33.3,28.2);

	this.tiger_head_2 = new lib.TigerHead_002();
	this.tiger_head_2.parent = this;
	this.tiger_head_2.setTransform(108.3,178.5,0.515,0.515,2.8,0,0,-22.6,25.1);

	this.tiger_head_3 = new lib.TigerHead_003();
	this.tiger_head_3.parent = this;
	this.tiger_head_3.setTransform(102.7,183.1,0.515,0.515,4.7,0,0,-22.7,24.4);

	this.tiger_head_4 = new lib.TigerHead_004_wet();
	this.tiger_head_4.parent = this;
	this.tiger_head_4.setTransform(152.6,171.2,0.515,0.515,0,0,0,33.3,28.2);

	this.tiger_head_5 = new lib.TigerHead_roar_001_1();
	this.tiger_head_5.parent = this;
	this.tiger_head_5.setTransform(137.1,177.5,0.515,0.515,-6.2,0,0,33,27.7);
	this.tiger_head_5._off = true;

	this.tiger_head_6 = new lib.TigerHead_roar_002_1();
	this.tiger_head_6.parent = this;
	this.tiger_head_6.setTransform(142.5,173.7,0.515,0.515,-6.2,0,0,33,27.7);

	this.tiger_head_7 = new lib.TigerHead_roar_004_1();
	this.tiger_head_7.parent = this;
	this.tiger_head_7.setTransform(143.3,168,0.515,0.515,8.8,0,0,32.4,27.8);
	this.tiger_head_7._off = true;

	this.tiger_head_8 = new lib.TigerHead_roar_003_1();
	this.tiger_head_8.parent = this;
	this.tiger_head_8.setTransform(142.9,163.1,0.515,0.515,14.3,0,0,32.6,27.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tiger_head}]}).to({state:[{t:this.tiger_head}]},28).to({state:[{t:this.tiger_head_1,p:{y:171.2}}]},6).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head_2,p:{regX:-22.6,regY:25.1,rotation:2.8,x:108.3,y:178.5}}]},2).to({state:[{t:this.tiger_head_3}]},2).to({state:[{t:this.tiger_head_3}]},109).to({state:[{t:this.tiger_head_2,p:{regX:-22.7,regY:24.4,rotation:3.3,x:107.5,y:178.7}}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head_1,p:{y:174.1}}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head_1,p:{y:171.2}}]},94).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},20).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head_1,p:{y:171.2}}]},2).to({state:[{t:this.tiger_head}]},2).to({state:[{t:this.tiger_head_4}]},26).to({state:[{t:this.tiger_head_5}]},26).to({state:[{t:this.tiger_head_5}]},12).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_6}]},2).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_8}]},2).to({state:[{t:this.tiger_head_7}]},18).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_6}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},56).to({state:[{t:this.tiger_head_5}]},1).to({state:[{t:this.tiger_head_5}]},1).to({state:[{t:this.tiger_head_5}]},1).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_5}]},2).to({state:[{t:this.tiger_head_6}]},2).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_8}]},2).to({state:[{t:this.tiger_head_7}]},12).to({state:[{t:this.tiger_head_7}]},2).to({state:[{t:this.tiger_head_6}]},2).to({state:[{t:this.tiger_head_5}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.tiger_head).wait(28).to({_off:true},6).wait(2).to({_off:false,regX:-22.9,regY:25.1,skewX:-1,skewY:179,x:137,y:173.6},0).to({_off:true},2).wait(115).to({_off:false,y:177.5},0).to({_off:true},2).wait(2).to({_off:false,regX:33.3,regY:28.2,skewX:0,skewY:0,x:152.6,y:171.2},0).to({_off:true},94).wait(2).to({_off:false,regX:-22.9,regY:25.1,skewX:-1,skewY:179,x:137,y:173.6},0).wait(2).to({regY:25,skewX:-2.3,skewY:177.7,x:135.4,y:176.8},0).wait(2).to({regX:-22.4,regY:24.2,skewX:-3.3,skewY:176.7,x:133.4,y:179.6},0).wait(2).to({regX:-22.7,regY:24.4,skewX:-4.7,skewY:175.3,x:132.1,y:183.1},0).wait(22).to({regY:26.9,skewX:-3.3,skewY:176.7,x:133.8,y:181.2},0).wait(2).to({regX:-22.9,regY:24.4,skewX:-2.3,skewY:177.7,x:135.5,y:176.8},0).wait(2).to({regY:25.1,skewX:-1,skewY:179,x:137,y:173.6},0).to({_off:true},2).wait(2).to({_off:false,regX:33.3,regY:28.2,skewX:0,skewY:0,x:152.6,y:171.2},0).to({_off:true},26).wait(180));
	this.timeline.addTween(cjs.Tween.get(this.tiger_head_5).wait(341).to({_off:false},0).wait(12).to({y:176.7},0).wait(2).to({y:177.5},0).wait(2).to({regX:32.9,rotation:-1.3,x:134.8,y:189.8},0).wait(2).to({regX:33,regY:28.2,rotation:3.5,x:132.5,y:202.2},0).wait(2).to({regX:33.1,regY:28.1,rotation:0,x:132.6,y:203.9},0).wait(2).to({regY:27.9,rotation:-3.2,y:205.8},0).wait(2).to({regX:34.2,regY:27.8,rotation:-4.5,x:135.4,y:191.5},0).wait(2).to({regX:33,regY:27.7,rotation:-6.2,x:137.1,y:177.5},0).to({_off:true},2).wait(30).to({_off:false},0).wait(57).to({y:176.7},0).wait(1).to({y:177.5},0).wait(1).to({regX:32.9,rotation:-1.3,x:134.8,y:189.8},0).wait(2).to({regX:33,regY:28.2,rotation:3.5,x:132.5,y:202.2},0).wait(2).to({regX:33.1,regY:28.1,rotation:0,x:132.6,y:203.9},0).wait(2).to({regY:27.9,rotation:-3.2,y:205.8},0).wait(2).to({regX:34.2,regY:27.8,rotation:-4.5,x:135.4,y:191.5},0).wait(2).to({regX:33,regY:27.7,rotation:-6.2,x:137.1,y:177.5},0).to({_off:true},2).wait(24).to({_off:false},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.tiger_head_7).wait(371).to({_off:false},0).wait(2).to({regX:32.9,regY:27.7,rotation:14.7,x:142.8},0).to({_off:true},2).wait(18).to({_off:false},0).wait(2).to({regX:32.4,regY:27.8,rotation:8.8,x:143.3},0).to({_off:true},2).wait(75).to({_off:false},0).wait(2).to({regX:32.9,regY:27.7,rotation:14.7,x:142.8},0).to({_off:true},2).wait(12).to({_off:false},0).wait(2).to({regX:32.4,regY:27.8,rotation:8.8,x:143.3},0).to({_off:true},2).wait(3));

	// Tiger Neck
	this.instance_6 = new lib.TigerNeck_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(138.5,169.9,0.468,0.468);

	this.instance_7 = new lib.TigerNeck_wet_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(138.5,169.9,0.468,0.468);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_6}]},28).to({state:[{t:this.instance_6}]},8).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},109).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},96).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},20).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},28).to({state:[{t:this.instance_6}]},26).to({state:[{t:this.instance_6}]},12).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},18).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},56).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},12).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(36).to({scaleX:0.49,scaleY:0.47,skewX:-2.8,skewY:-4,x:137.5,y:172.5},0).wait(2).to({scaleX:0.52,scaleY:0.46,skewX:-7.1,skewY:-10.3,x:135.9,y:176.5},0).wait(2).to({scaleX:0.55,scaleY:0.46,skewX:-11.7,skewY:-16.8,x:134.3,y:180.5},0).wait(111).to({scaleX:0.53,scaleY:0.46,skewX:-8.6,skewY:-12.5,x:135.4,y:177.8},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:-5.8,skewY:-8.3,x:136.4,y:175.2},0).wait(2).to({scaleX:0.49,scaleY:0.47,skewX:-2.8,skewY:-4,x:137.5,y:172.5},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:0,x:138.5,y:169.9},0).wait(96).to({scaleX:0.49,scaleY:0.47,skewX:-2.8,skewY:-4,x:137.5,y:172.5},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:-5.8,skewY:-8.3,x:136.5,y:175.2},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:-8.6,skewY:-12.5,x:135.4,y:177.9},0).wait(2).to({scaleX:0.55,scaleY:0.46,skewX:-11.7,skewY:-16.8,x:134.3,y:180.5},0).wait(22).to({scaleX:0.53,scaleY:0.46,skewX:-8.6,skewY:-12.5,x:135.4,y:177.8},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:-5.8,skewY:-8.3,x:136.4,y:175.2},0).wait(2).to({scaleX:0.49,scaleY:0.47,skewX:-2.8,skewY:-4,x:137.5,y:172.5},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:0,x:138.5,y:169.9},0).to({_off:true},28).wait(26).to({_off:false,regX:24.2,regY:9.8,x:149.8,y:174.5},0).wait(12).to({y:173.7},0).wait(2).to({y:174.5},0).wait(2).to({regY:9.7,scaleX:0.5,scaleY:0.46,rotation:-17.8,x:151,y:178.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,rotation:-35.6,x:152.3,y:182.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:152.2,y:184.8},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:152.3,y:187.2},0).wait(2).to({regY:9.8,scaleX:0.5,scaleY:0.46,rotation:-17.8,x:151.1,y:180.9},0).wait(2).to({scaleX:0.47,scaleY:0.47,rotation:0,x:149.8,y:174.5},0).wait(4).to({regX:23.9,regY:10.2,scaleX:0.59,scaleY:0.45,skewX:1.1,skewY:1,x:154.8,y:169.3},0).wait(2).to({rotation:5.1,skewX:0,skewY:0,x:153.2,y:168.3},0).wait(2).to({regY:10.1,rotation:0,skewX:9.4,skewY:9.2,x:151.6,y:167.3},0).wait(18).to({regX:25.4,regY:8.8,rotation:5.1,skewX:0,skewY:0,x:154.1,y:167.7},0).wait(2).to({regX:23.9,regY:10.2,rotation:0,skewX:1.1,skewY:1,x:154.8,y:169.3},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:0.5,skewY:0.3,x:152.3,y:171.9},0).wait(2).to({regX:24.2,regY:9.8,scaleX:0.47,scaleY:0.47,skewX:0,skewY:0,x:149.8,y:174.5},0).wait(57).to({y:173.7},0).wait(1).to({y:174.5},0).wait(1).to({regY:9.7,scaleX:0.5,scaleY:0.46,rotation:-17.8,x:151,y:178.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,rotation:-35.6,x:152.3,y:182.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:152.2,y:184.8},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:152.3,y:187.2},0).wait(2).to({regY:9.8,scaleX:0.5,scaleY:0.46,rotation:-17.8,x:151.1,y:180.9},0).wait(2).to({scaleX:0.47,scaleY:0.47,rotation:0,x:149.8,y:174.5},0).wait(4).to({regX:23.9,regY:10.2,scaleX:0.59,scaleY:0.45,skewX:1.1,skewY:1,x:154.8,y:169.3},0).wait(2).to({rotation:5.1,skewX:0,skewY:0,x:153.2,y:168.3},0).wait(2).to({regY:10.1,rotation:0,skewX:9.4,skewY:9.2,x:151.6,y:167.3},0).wait(12).to({regX:25.4,regY:8.8,rotation:5.1,skewX:0,skewY:0,x:154.1,y:167.7},0).wait(2).to({regX:23.9,regY:10.2,rotation:0,skewX:1.1,skewY:1,x:154.8,y:169.3},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:0.5,skewY:0.3,x:152.3,y:171.9},0).wait(2).to({regX:24.2,regY:9.8,scaleX:0.47,scaleY:0.47,skewX:0,skewY:0,x:149.8,y:174.5},0).wait(1));

	// Tiger Hind Leg
	this.tiger_hindleg = new lib.TigerHindLeg();
	this.tiger_hindleg.parent = this;
	this.tiger_hindleg.setTransform(237.7,178,0.468,0.468,0,0,0,-14.3,-58.7);

	this.timeline.addTween(cjs.Tween.get(this.tiger_hindleg).wait(36).to({regX:-16.3,skewX:-0.3,x:236.4},0).wait(2).to({regX:-16.2,skewX:-0.8,x:235.9,y:177.9},0).wait(2).to({regX:-14.2,skewX:-1.3,x:236.1,y:178},0).wait(111).to({skewX:-0.8,x:236.8},0).wait(2).to({regX:-14.3,skewX:-0.5,x:237.3,y:177.9},0).wait(2).to({regX:-16.3,skewX:-0.3,x:236.6,y:178},0).wait(2).to({regX:-14.3,skewX:0,x:237.7},0).wait(96).to({regX:-16.3,skewX:-0.3,x:236.4},0).wait(2).to({regX:-16.2,skewX:-0.5,x:236.1,y:177.9},0).wait(2).to({regX:-16.3,skewX:-0.8,x:235.6,y:178},0).wait(2).to({regX:-14.2,skewX:-1.3,x:236.1},0).wait(22).to({skewX:-0.8,x:236.6},0).wait(2).to({regX:-14.3,skewX:-0.5,x:236.9,y:177.9},0).wait(2).to({regX:-16.3,skewX:-0.3,x:236.4,y:178},0).wait(2).to({regX:-14.3,skewX:0,x:237.7},0).wait(66).to({regX:0.1,regY:94.5,scaleY:0.48,x:244.5,y:249.6},0).wait(2).to({skewX:-0.4},0).wait(2).to({skewX:-1},0).wait(2).to({skewX:-1.6},0).wait(2).to({regY:94.4,scaleY:0.48,skewX:-2.5,x:244.4},0).wait(2).to({scaleY:0.49,skewX:-3.5,y:249.5},0).wait(2).to({regX:0.8,regY:94.3,scaleY:0.48,skewX:-1.8,x:244.7,y:249.6},0).wait(2).to({regX:0.1,regY:94.5,scaleY:0.48,skewX:-0.4,x:244.5},0).wait(2).to({regY:94.4,scaleY:0.46,skewX:0,x:244.6},0).wait(2).to({regX:10.3,scaleY:0.45,skewX:0.4,x:249.2},0).wait(2).to({regX:6,skewX:0,x:247.4},0).wait(2).to({regX:0.2,skewX:-0.7,x:244.7},0).wait(18).to({skewX:0,x:244.3},0).wait(2).to({regX:6.2,skewX:0.4,x:247.1},0).wait(2).to({regX:6.1,scaleY:0.46,skewX:0},0).wait(2).to({regX:0.1,regY:94.5,scaleY:0.48,skewX:-0.4,x:244.5},0).wait(56).to({regX:-14.3,regY:-58.7,scaleY:0.47,skewX:0,x:237.7,y:178},0).wait(1).to({regX:0.1,regY:94.5,scaleY:0.48,x:244.5,y:249.6},0).wait(1).to({skewX:-0.4},0).wait(1).to({skewX:-1},0).wait(2).to({skewX:-1.6},0).wait(2).to({regY:94.4,scaleY:0.48,skewX:-2.5,x:244.4},0).wait(2).to({scaleY:0.49,skewX:-3.5,y:249.5},0).wait(2).to({regX:0.8,regY:94.3,scaleY:0.48,skewX:-1.8,x:244.7,y:249.6},0).wait(2).to({regX:0.1,regY:94.5,scaleY:0.48,skewX:-0.4,x:244.5},0).wait(2).to({regY:94.4,scaleY:0.46,skewX:0,x:244.6},0).wait(2).to({regX:10.4,scaleY:0.45,skewX:0.4,x:249.3},0).wait(2).to({regX:6,skewX:0,x:247.4},0).wait(2).to({regX:0.2,skewX:-0.7,x:244.7},0).wait(12).to({skewX:0,x:244.3},0).wait(2).to({regX:6.2,skewX:0.4,x:247.1},0).wait(2).to({regX:6.1,scaleY:0.46,skewX:0},0).wait(2).to({regX:0.1,regY:94.5,scaleY:0.48,skewX:-0.4,x:244.5},0).wait(1));

	// Tiger Front Leg
	this.tiger_frontleg = new lib.TigerFrontLeg();
	this.tiger_frontleg.parent = this;
	this.tiger_frontleg.setTransform(161.8,182.7,0.468,0.468,0,0,0,2.9,-61.6);

	this.timeline.addTween(cjs.Tween.get(this.tiger_frontleg).wait(36).to({scaleY:0.46,skewX:-0.3,x:161.4,y:184.1},0).wait(2).to({scaleY:0.44,skewX:-0.8,x:160.8,y:186.3},0).wait(2).to({scaleY:0.43,skewX:-1.6,x:160.2,y:188.3},0).wait(111).to({scaleY:0.44,skewX:-1,x:160.6,y:186.9},0).wait(2).to({regX:8.9,scaleY:0.45,skewX:-0.6,x:163.8,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.46,skewX:-0.3,x:161.4,y:184.1},0).wait(2).to({scaleY:0.47,skewX:0,x:161.8,y:182.7},0).wait(96).to({scaleY:0.46,skewX:-0.3,x:161.4,y:184.1},0).wait(2).to({regX:8.8,scaleY:0.45,skewX:-0.6,x:163.7,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.44,skewX:-1,x:160.5,y:186.9},0).wait(2).to({scaleY:0.43,skewX:-1.6,x:160.2,y:188.3},0).wait(22).to({scaleY:0.44,skewX:-1,x:160.6,y:186.9},0).wait(2).to({regX:8.9,scaleY:0.45,skewX:-0.6,x:163.8,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.46,skewX:-0.3,x:161.4,y:184.1},0).wait(2).to({scaleY:0.47,skewX:0,x:161.8,y:182.7},0).wait(28).to({_off:true},26).wait(154));

	// Tiger Torso
	this.tiger_torso = new lib.TigerTorso();
	this.tiger_torso.parent = this;
	this.tiger_torso.setTransform(179.2,173.1,0.468,0.468,0,0,0,-51.5,0);

	this.tiger_torso_1 = new lib.TigerTorso_wet();
	this.tiger_torso_1.parent = this;
	this.tiger_torso_1.setTransform(179.2,173.1,0.468,0.468,0,0,0,-51.5,0);

	this.tiger_torso_2 = new lib.TigerTorso_roar_001_1();
	this.tiger_torso_2.parent = this;
	this.tiger_torso_2.setTransform(179.2,173.1,0.468,0.468,0,0,0,-51.5,0);
	this.tiger_torso_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tiger_torso}]}).to({state:[{t:this.tiger_torso}]},28).to({state:[{t:this.tiger_torso}]},8).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},109).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},96).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},20).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso}]},2).to({state:[{t:this.tiger_torso_1}]},28).to({state:[{t:this.tiger_torso_2}]},26).to({state:[{t:this.tiger_torso_2}]},12).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},18).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},56).to({state:[{t:this.tiger_torso_2}]},1).to({state:[{t:this.tiger_torso_2}]},1).to({state:[{t:this.tiger_torso_2}]},1).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},12).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).to({state:[{t:this.tiger_torso_2}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.tiger_torso).wait(36).to({regX:-51.8,rotation:-1,x:178.6,y:174.3},0).wait(2).to({regX:-51.6,regY:-0.1,rotation:-2.8,x:177.8,y:176},0).wait(2).to({regY:0.1,rotation:-4.7,x:177.1,y:178},0).wait(111).to({regX:-51.5,regY:0,rotation:-3.3,x:177.6,y:176.7},0).wait(2).to({regX:-51.6,rotation:-2.3,x:178,y:175.5},0).wait(2).to({regX:-51.8,rotation:-1,x:178.6,y:174.3},0).wait(2).to({regX:-51.5,rotation:0,x:179.2,y:173.1},0).wait(96).to({regX:-51.8,rotation:-1,x:178.6,y:174.3},0).wait(2).to({regX:-51.6,rotation:-2.3,x:178.1,y:175.5},0).wait(2).to({regX:-51.8,rotation:-3.3,x:177.5,y:176.7},0).wait(2).to({regX:-51.6,regY:0.1,rotation:-4.7,x:177.1,y:178},0).wait(22).to({regX:-51.5,regY:0,rotation:-3.3,x:177.6,y:176.7},0).wait(2).to({regX:-51.6,rotation:-2.3,x:178,y:175.5},0).wait(2).to({regX:-51.8,rotation:-1,x:178.6,y:174.3},0).wait(2).to({regX:-51.5,rotation:0,x:179.2,y:173.1},0).to({_off:true},28).wait(180));
	this.timeline.addTween(cjs.Tween.get(this.tiger_torso_2).wait(341).to({_off:false},0).wait(12).to({y:172.3},0).wait(2).to({y:173.1},0).wait(2).to({regX:-51.6,regY:-0.1,scaleX:0.47,scaleY:0.47,rotation:-5,x:177,y:176.2},0).wait(2).to({regY:0,rotation:-10.3,x:174.9,y:179.4},0).wait(2).to({regY:0.6,rotation:-12.6,x:175,y:181.2},0).wait(2).to({regX:-51.5,regY:0,rotation:-15,y:182.6},0).wait(2).to({rotation:-7.5,x:177.1,y:177.8},0).wait(2).to({scaleX:0.47,scaleY:0.47,rotation:0,x:179.2,y:173.1},0).wait(2).to({regX:-51.6,regY:0.1,rotation:2.3},0).wait(2).to({regX:-51.5,regY:-0.1,rotation:5,y:173},0).wait(2).to({regX:-51.6,rotation:6.3,x:178.6,y:172.2},0).wait(2).to({rotation:7.7,x:178,y:171.4},0).wait(18).to({rotation:6.3,x:178.6,y:172.2},0).wait(2).to({regX:-51.5,rotation:5,x:179.2,y:173},0).wait(2).to({regY:0.1,rotation:2.3,y:173.1},0).wait(2).to({regY:0,rotation:0},0).wait(57).to({y:172.3},0).wait(1).to({y:173.1},0).wait(1).to({regX:-51.6,regY:-0.1,scaleX:0.47,scaleY:0.47,rotation:-5,x:177,y:176.2},0).wait(2).to({regY:0,rotation:-10.3,x:174.9,y:179.4},0).wait(2).to({regY:0.6,rotation:-12.6,x:175,y:181.2},0).wait(2).to({regX:-51.5,regY:0,rotation:-15,y:182.6},0).wait(2).to({rotation:-7.5,x:177.1,y:177.8},0).wait(2).to({scaleX:0.47,scaleY:0.47,rotation:0,x:179.2,y:173.1},0).wait(2).to({regX:-51.6,regY:0.1,rotation:2.3},0).wait(2).to({regX:-51.5,regY:-0.1,rotation:5,y:173},0).wait(2).to({regX:-51.6,rotation:6.3,x:178.6,y:172.2},0).wait(2).to({rotation:7.7,x:178,y:171.4},0).wait(12).to({rotation:6.3,x:178.6,y:172.2},0).wait(2).to({regX:-51.5,rotation:5,x:179.2,y:173},0).wait(2).to({regY:0.1,rotation:2.3,y:173.1},0).wait(2).to({regY:0,rotation:0},0).wait(1));

	// Tiger Tail
	this.instance_8 = new lib.TigerTail_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(245.5,169,0.468,0.468,0,0,0,-30.1,-54.4);

	this.instance_9 = new lib.TigerTail_loop();
	this.instance_9.parent = this;
	this.instance_9.setTransform(245.5,169,0.468,0.468,0,0,0,-30.1,-54.4);
	this.instance_9._off = true;

	this.instance_10 = new lib.TigerTailLoop2();
	this.instance_10.parent = this;
	this.instance_10.setTransform(243.6,169,0.468,0.468,-9.9,0,0,-30.1,-54.6);
	this.instance_10._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},28).to({state:[{t:this.instance_9}]},8).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_9}]},109).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},16).to({state:[{t:this.instance_9}]},72).to({state:[{t:this.instance_9}]},8).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},20).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_8}]},6).to({state:[{t:this.instance_8}]},22).to({state:[{t:this.instance_10}]},26).to({state:[{t:this.instance_10}]},12).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},18).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},56).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},12).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_10}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(28).to({_off:false},0).wait(8).to({regX:-28.2,regY:-54.2,rotation:-2.3,x:245.9},0).wait(2).to({regX:-28.4,regY:-54.4,rotation:-6,x:244.7,y:168.9},0).to({_off:true},2).wait(109).to({_off:false,regX:-30.1,regY:-54.6,rotation:-9.9,x:243.6,y:169},0).wait(2).to({regX:-30,regY:-54.4,rotation:-7.3,x:244.4,y:169.1},0).wait(2).to({regY:-54.6,rotation:-4.8,x:245.1,y:169},0).wait(2).to({regX:-28.2,regY:-54.2,rotation:-2.3,x:245.9},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:0,x:245.5},0).to({_off:true},16).wait(72).to({_off:false},0).wait(8).to({regX:-28.2,regY:-54.2,rotation:-2.3,x:245.9},0).wait(2).to({regX:-28.3,regY:-54.3,rotation:-4.8,x:245.1},0).wait(2).to({regX:-27.6,regY:-53.8,rotation:-7.3,x:244.7,y:169.2},0).wait(2).to({regX:-30.1,regY:-54.6,rotation:-9.9,x:243.6,y:169},0).wait(22).to({regX:-30,regY:-54.4,rotation:-7.3,x:244.4,y:169.1},0).wait(2).to({regY:-54.6,rotation:-4.8,x:245.1,y:169},0).wait(2).to({regX:-28.2,regY:-54.2,rotation:-2.3,x:245.9},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:0,x:245.5},0).to({_off:true},6).wait(202));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(40).to({_off:false},0).to({_off:true},109).wait(24).to({_off:false,regY:-54.4,rotation:0,x:245.5},0).to({_off:true},72).wait(96).to({_off:false},0).wait(12).to({rotation:2.7,y:169.1},0).wait(2).to({rotation:0,y:169},0).wait(2).to({regX:-30.2,regY:-54.8,scaleX:0.47,scaleY:0.47,rotation:-7.3,x:242.5,y:166.2},0).wait(2).to({regX:-30.4,regY:-53.4,rotation:-14.5,x:239.8,y:163.8},0).wait(2).to({regY:-53.3,rotation:-16.8,y:163.6},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:-19,y:163.4},0).wait(2).to({regX:-30.2,regY:-54.3,rotation:-9.5,x:242.6,y:166.3},0).wait(2).to({regX:-30.1,regY:-54.4,scaleX:0.47,scaleY:0.47,rotation:0,x:245.5,y:169},0).wait(2).to({regY:-54.5,rotation:-1.3,x:245.4,y:171.4},0).wait(2).to({regX:-27.4,regY:-54.8,rotation:-2.7,x:245.1,y:173.9},0).wait(2).to({regY:-55,rotation:0,x:243.7,y:174},0).wait(2).to({regX:-29.8,regY:-54.6,rotation:2.5,x:242.4,y:174.1},0).wait(18).to({regY:-55,rotation:0,x:243.7,y:173.8},0).wait(2).to({regX:-27.4,regY:-54.8,rotation:-2.7,x:245.1,y:173.9},0).wait(2).to({regY:-54.7,rotation:-1.3,x:245.3,y:171.5},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:0,x:245.5,y:169},0).wait(57).to({rotation:2.7,y:169.1},0).wait(1).to({rotation:0,y:169},0).wait(1).to({regX:-30.2,regY:-54.8,scaleX:0.47,scaleY:0.47,rotation:-7.3,x:242.5,y:166.2},0).wait(2).to({regX:-30.4,regY:-53.4,rotation:-14.5,x:239.8,y:163.8},0).wait(2).to({regY:-53.3,rotation:-16.8,y:163.6},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:-19,y:163.4},0).wait(2).to({regX:-30.2,regY:-54.3,rotation:-9.5,x:242.6,y:166.3},0).wait(2).to({regX:-30.1,regY:-54.4,scaleX:0.47,scaleY:0.47,rotation:0,x:245.5,y:169},0).wait(2).to({regY:-54.5,rotation:-1.3,x:245.4,y:171.4},0).wait(2).to({regX:-27.4,regY:-54.8,rotation:-2.7,x:245.1,y:173.9},0).wait(2).to({regY:-55,rotation:0,x:243.7,y:174},0).wait(2).to({regX:-29.8,regY:-54.6,rotation:2.5,x:242.4,y:174.1},0).wait(12).to({regY:-55,rotation:0,x:243.7,y:173.8},0).wait(2).to({regX:-27.4,regY:-54.8,rotation:-2.7,x:245.1,y:173.9},0).wait(2).to({regY:-54.7,rotation:-1.3,x:245.3,y:171.5},0).wait(2).to({regX:-30.1,regY:-54.4,rotation:0,x:245.5,y:169},0).wait(1));

	// Tiger Hind Leg Back
	this.tiger_hindlegback = new lib.TigerHindLegBack();
	this.tiger_hindlegback.parent = this;
	this.tiger_hindlegback.setTransform(225.2,176.7,0.468,0.468,0,0,0,-14.3,-51.5);

	this.tiger_hindlegback_1 = new lib.TigerHindLegBackcopy();
	this.tiger_hindlegback_1.parent = this;
	this.tiger_hindlegback_1.setTransform(225.2,176.7,0.468,0.468,0,0,0,-14.3,-51.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tiger_hindlegback}]}).to({state:[{t:this.tiger_hindlegback}]},28).to({state:[{t:this.tiger_hindlegback}]},8).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},109).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},96).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},20).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},2).to({state:[{t:this.tiger_hindlegback}]},28).to({state:[{t:this.tiger_hindlegback_1}]},26).to({state:[{t:this.tiger_hindlegback_1}]},114).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.tiger_hindlegback).wait(36).to({regX:-14,skewX:-0.3,x:225},0).wait(2).to({skewX:-0.8,x:224.3,y:176.6},0).wait(2).to({regX:-14.3,skewX:-1.3,x:223.6,y:176.7},0).wait(111).to({skewX:-0.8,x:224.1},0).wait(2).to({regX:-14,skewX:-0.5,x:224.7},0).wait(2).to({skewX:-0.3,x:225},0).wait(2).to({regX:-14.3,skewX:0,x:225.2},0).wait(96).to({regX:-14,skewX:-0.3,x:225},0).wait(2).to({regX:-7.9,skewX:-0.5,x:227.4},0).wait(2).to({regX:-13.8,skewX:-0.8,x:224.1},0).wait(2).to({regX:-14.3,skewX:-1.3,x:223.6},0).wait(22).to({skewX:-0.8,x:224.1},0).wait(2).to({regX:-14,skewX:-0.5,x:224.7},0).wait(2).to({skewX:-0.3,x:225},0).wait(2).to({regX:-14.3,skewX:0,x:225.2},0).wait(28).to({_off:true},26).wait(154));

	// Tiger Front Leg Back
	this.tiger_frontlegback = new lib.TigerFrontLegBack();
	this.tiger_frontlegback.parent = this;
	this.tiger_frontlegback.setTransform(149.9,176.4,0.468,0.468,0,0,0,0,-63);

	this.timeline.addTween(cjs.Tween.get(this.tiger_frontlegback).wait(36).to({scaleY:0.46,skewX:-0.3,x:149.5,y:177.8},0).wait(2).to({regX:-0.1,regY:-63.1,scaleY:0.44,skewX:-0.8,x:148.8,y:179.9},0).wait(2).to({scaleY:0.43,skewX:-1.6,x:148.2,y:182},0).wait(111).to({scaleY:0.44,skewX:-1,x:148.6,y:180.7},0).wait(2).to({regX:0.9,scaleY:0.45,skewX:-0.6,x:149.5,y:179.2},0).wait(2).to({regX:0,regY:-63,scaleY:0.46,skewX:-0.3,y:177.8},0).wait(2).to({scaleY:0.47,skewX:0,x:149.9,y:176.4},0).wait(96).to({scaleY:0.46,skewX:-0.3,x:149.5,y:177.8},0).wait(2).to({regX:0.1,scaleY:0.45,skewX:-0.6,x:149.1,y:179.2},0).wait(2).to({regX:0,scaleY:0.44,skewX:-1,x:148.6,y:180.6},0).wait(2).to({regX:-0.1,regY:-63.1,scaleY:0.43,skewX:-1.6,x:148.2,y:182},0).wait(22).to({scaleY:0.44,skewX:-1,x:148.6,y:180.7},0).wait(2).to({regX:0.9,scaleY:0.45,skewX:-0.6,x:149.5,y:179.2},0).wait(2).to({regX:0,regY:-63,scaleY:0.46,skewX:-0.3,y:177.8},0).wait(2).to({scaleY:0.47,skewX:0,x:149.9,y:176.4},0).wait(66).to({regX:-5.5,regY:79.6,scaleY:0.48,x:147.3,y:243.1},0).wait(2).to({regY:79.7,scaleY:0.46},0).wait(2).to({regX:-9.8,regY:79.6,scaleY:0.47,skewX:3.5,x:145.1},0).wait(2).to({regX:-6.2,regY:79.7,scaleY:0.47,skewX:7.2,x:147},0).wait(2).to({scaleY:0.47,skewX:8.5},0).wait(2).to({regX:-5.9,scaleY:0.47,skewX:9.8,x:147.1},0).wait(2).to({regY:79.6,scaleY:0.47,skewX:4.8,x:147.2,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:147.3,y:243.1},0).wait(2).to({scaleY:0.46,skewX:2},0).wait(2).to({skewX:4.1},0).wait(2).to({scaleY:0.47,skewX:4,x:147.4},0).wait(2).to({regX:-0.4,scaleY:0.48,skewX:4.1,x:149.7},0).wait(18).to({regX:-4.8,regY:79.5,scaleY:0.47,skewX:4,x:147.4,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:4.1,x:147.3,y:243.1},0).wait(2).to({skewX:2,x:147.2},0).wait(2).to({scaleY:0.46,skewX:0,x:147.3},0).wait(56).to({regX:0,regY:-63,scaleY:0.47,x:149.9,y:176.4},0).wait(1).to({regX:-5.5,regY:79.6,scaleY:0.48,x:147.3,y:243.1},0).wait(1).to({regY:79.7,scaleY:0.46},0).wait(1).to({regX:-9.9,regY:79.6,scaleY:0.47,skewX:3.5,x:145},0).wait(2).to({regX:-6.2,regY:79.7,scaleY:0.47,skewX:7.2,x:147},0).wait(2).to({scaleY:0.47,skewX:8.5},0).wait(2).to({regX:-5.9,scaleY:0.47,skewX:9.8,x:147.1},0).wait(2).to({regY:79.6,scaleY:0.47,skewX:4.8,x:147.2,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:147.3,y:243.1},0).wait(2).to({scaleY:0.46,skewX:2},0).wait(2).to({skewX:4.1},0).wait(2).to({scaleY:0.47,skewX:4,x:147.4},0).wait(2).to({regX:-0.4,scaleY:0.48,skewX:4.1,x:149.7},0).wait(12).to({regX:-4.8,regY:79.5,scaleY:0.47,skewX:4,x:147.4,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:4.1,x:147.3,y:243.1},0).wait(2).to({skewX:2,x:147.2},0).wait(2).to({scaleY:0.46,skewX:0,x:147.3},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(112,132.2,173.8,124);


(lib.tiger = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mouthGlow
	this.mouthGlow = new lib.tiger_mouthGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(134.8,132.4,1,1,0,0,0,16.4,12.8);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.mouthGlow.cache(-4,-5,41,35);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// pawGlow
	this.pawGlow = new lib.tiger_pawGlow();
	this.pawGlow.parent = this;
	this.pawGlow.setTransform(162.5,221.3,1,1,0,0,0,17.8,20);
	this.pawGlow.alpha = 0;
	this.pawGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.pawGlow.cache(-20,12,176,30);

	this.timeline.addTween(cjs.Tween.get(this.pawGlow).wait(1));

	// backGlow
	this.backGlow = new lib.tiger_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(214.3,134.6,1.123,1.06,1.2,0,0,51.6,18.4);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(2,-4,101,45);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.tiger_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(275.1,182.7,1,1,0,0,0,22.2,56.4);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.legGlow.cache(-115,-4,163,109);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// tail1
	this.tail1 = new lib.invisiblebox();
	this.tail1.parent = this;
	this.tail1.setTransform(312.4,207,0.469,0.516,0,100,87.9);

	this.timeline.addTween(cjs.Tween.get(this.tail1).wait(1));

	// leg2
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(160.1,183,0.964,1.187,0,0.4,1.2);

	this.timeline.addTween(cjs.Tween.get(this.leg2).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(293.7,169.6,1.93,0.314,0,100,87.9);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// leg1
	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(271.5,169,0.664,2.005,0,0.4,1.2);

	this.timeline.addTween(cjs.Tween.get(this.leg1).wait(1));

	// ear
	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(125.4,95.7,1.496,0.309,0,2.2,0);

	this.timeline.addTween(cjs.Tween.get(this.ear).wait(1));

	// mouth
	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(117.6,132.3,1.552,0.694);

	this.timeline.addTween(cjs.Tween.get(this.mouth).wait(1));

	// tummy
	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(213.1,177.7,1.456,0.834);

	this.timeline.addTween(cjs.Tween.get(this.tummy).wait(1));

	// paw1
	this.paw1 = new lib.invisiblebox();
	this.paw1.parent = this;
	this.paw1.setTransform(154,224.9,1.315,0.789,5);

	this.timeline.addTween(cjs.Tween.get(this.paw1).wait(1));

	// paw2
	this.paw2 = new lib.invisiblebox();
	this.paw2.parent = this;
	this.paw2.setTransform(267.9,225.6,1.601,0.668,3.8);

	this.timeline.addTween(cjs.Tween.get(this.paw2).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(211.4,132.1,2.275,0.993,-1.2);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// main
	this.main = new lib.Tiger();
	this.main.parent = this;
	this.main.setTransform(478,-13,1.291,1.291,0,0,180,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.tiger, new cjs.Rectangle(85.8,86.3,274,160.5), null);


// stage content:
(lib.MWtiger = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"rest":0,"wrongAnswer":245,"clean":295,"wet":315,"excited":341,"animalSound":455});

	// timeline functions:
	this.frame_25 = function() {
		playSound("sesame_murray_bengal_tiger_04_close_purr_02");
	}
	this.frame_243 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_248 = function() {
		playSound("sesame_murray_bengal_tiger_01_distant_purr_01");
	}
	this.frame_293 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_313 = function() {
		/* stop();*/
	}
	this.frame_339 = function() {
		/* stop();*/
	}
	this.frame_348 = function() {
		playSound("sesame_murray_bengal_tiger_06_outro_roar");
	}
	this.frame_405 = function() {
		playSound("GleamAfterDrying5wav");
	}
	this.frame_451 = function() {
		/* 
		
		gameObjects._game.done();
		
		stop();*/
	}
	this.frame_494 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(25).call(this.frame_25).wait(218).call(this.frame_243).wait(5).call(this.frame_248).wait(45).call(this.frame_293).wait(20).call(this.frame_313).wait(26).call(this.frame_339).wait(9).call(this.frame_348).wait(57).call(this.frame_405).wait(46).call(this.frame_451).wait(43).call(this.frame_494).wait(1));

	// Layer 4
	this.instance_11 = new lib.TigerHindLeg_bubbles();
	this.instance_11.parent = this;
	this.instance_11.setTransform(184.8,178,0.468,0.468,0,0,180,-14.3,-58.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).to({_off:true},315).wait(180));

	// Tiger Head_004
	this.instance_12 = new lib.TigerHead_004_bubbles();
	this.instance_12.parent = this;
	this.instance_12.setTransform(270,171.2,0.515,0.515,0,0,180,33.3,28.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true},315).wait(180));

	// Tiger Front Leg
	this.instance_13 = new lib.TigerFrontLeg_bubbles();
	this.instance_13.parent = this;
	this.instance_13.setTransform(260.8,182.7,0.468,0.468,0,0,180,2.9,-61.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).to({_off:true},315).wait(180));

	// Tiger Torso
	this.instance_14 = new lib.TigerTorso_bubbles();
	this.instance_14.parent = this;
	this.instance_14.setTransform(243.3,173.1,0.468,0.468,0,0,180,-51.5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true},315).wait(180));

	// Layer 3
	this.instance_15 = new lib.water_drops_016();
	this.instance_15.parent = this;
	this.instance_15.setTransform(263,208.1,0.6,0.6,0,0,180,92.4,49.1);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(315).to({_off:false},0).to({_off:true},26).wait(154));

	// sparkle
	this.instance_16 = new lib.sparkle();
	this.instance_16.parent = this;
	this.instance_16.setTransform(178.4,204.9,0.75,0.75);
	this.instance_16._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(412).to({_off:false},0).to({_off:true},43).wait(40));

	// sparkle
	this.instance_17 = new lib.sparkle();
	this.instance_17.parent = this;
	this.instance_17.setTransform(270,195.2,0.75,0.75);
	this.instance_17._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(427).to({_off:false},0).to({_off:true},28).wait(40));

	// sparkle
	this.instance_18 = new lib.sparkle();
	this.instance_18.parent = this;
	this.instance_18.setTransform(238.4,165.1,0.75,0.75);
	this.instance_18._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(419).to({_off:false},0).to({_off:true},36).wait(40));

	// sparkle
	this.instance_19 = new lib.sparkle();
	this.instance_19.parent = this;
	this.instance_19.setTransform(217.4,195.2,0.75,0.75);
	this.instance_19._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(433).to({_off:false},0).to({_off:true},22).wait(40));

	// sparkle
	this.instance_20 = new lib.sparkle();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-376.9,-129.4,0.75,0.75);
	this.instance_20._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(405).to({_off:false},0).to({_off:true},50).wait(40));

	// Layer 11
	this.instance_21 = new lib.Tiger_blink_001();
	this.instance_21.parent = this;
	this.instance_21.setTransform(286.5,151.3,1,1,0,0,0,11.7,4.5);

	this.instance_22 = new lib.Tiger_blink_002();
	this.instance_22.parent = this;
	this.instance_22.setTransform(286.5,151.3,1,1,0,0,0,11.7,4.5);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDA92D").s().p("AgkAgQgLgKgDgOIAAAAQAvAPA2gPQgzgjgyAjIgBgIQAAgSAPgNQAPgNAVgBQAVABAPANQAPANABASIgBAIIAAAAQgDAOgMAKQgPANgVAAQgVAAgPgNg");
	this.shape.setTransform(280,151.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FDA92D").s().p("AgjAgQgNgLgCgOQAzAQAygQQgpgng8AnQAAgZAPgNQAPgNAUgBQAWABAPANQAOANAAAZQgCAOgMALQgPANgWAAQgUAAgPgNg");
	this.shape_1.setTransform(293.1,151.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_21}]},12).to({state:[{t:this.instance_22}]},1).to({state:[{t:this.shape_1},{t:this.shape}]},2).to({state:[]},1).to({state:[{t:this.instance_21}]},207).to({state:[{t:this.instance_22}]},1).to({state:[{t:this.shape_1},{t:this.shape}]},2).to({state:[]},1).wait(268));

	// Tiger Front Leg
	this.instance_23 = new lib.TigerFrontLeg_roar_001();
	this.instance_23.parent = this;
	this.instance_23.setTransform(263.3,248.7,0.468,0.468,0,0,180,-2.6,79.4);
	this.instance_23._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(341).to({_off:false},0).wait(12).to({regY:79.3,scaleY:0.48,y:248.6},0).wait(2).to({regY:79.4,scaleY:0.47,y:248.7},0).wait(2).to({regX:-2.5,scaleY:0.46,skewX:-2.8,y:248.6},0).wait(2).to({regX:-2.4,regY:79.3,scaleY:0.45,skewX:-5.8,x:263.2},0).wait(2).to({regY:79.4,scaleY:0.44,y:248.7},0).wait(2).to({regY:79.5,scaleY:0.43,skewX:-6.1},0).wait(2).to({scaleY:0.45,skewX:-3,x:263.1,y:248.9},0).wait(2).to({regX:-6,regY:81.5,scaleY:0.47,skewX:0,x:264.9,y:249.6},0).wait(2).to({regX:-6.2,scaleY:0.48,x:265.1,y:250.1},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,skewX:0.3,x:261.9,y:249.6},0).wait(2).to({regX:-0.1,scaleY:0.49,x:262.1},0).wait(2).to({regX:-6.9,regY:81.5,scaleY:0.5,skewX:0.5,x:264.9,y:249.7},0).wait(18).to({regX:-7,regY:81.6,scaleY:0.49,skewX:0.3,x:265.4},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,x:261.9,y:249.6},0).wait(2).to({regX:-0.1,regY:81.5,scaleY:0.48,skewX:0,x:262.3,y:249.9},0).wait(2).to({regX:-6,scaleY:0.47,x:264.9,y:249.4},0).wait(56).to({regX:-2.6,regY:79.4,x:263.3,y:248.7},0).wait(1).to({regY:79.3,scaleY:0.48,y:248.6},0).wait(1).to({regY:79.4,scaleY:0.47,y:248.7},0).wait(1).to({regX:-2.5,scaleY:0.46,skewX:-2.8,y:248.6},0).wait(2).to({regX:-2.4,regY:79.3,scaleY:0.45,skewX:-5.8,x:263.2},0).wait(2).to({regY:79.4,scaleY:0.44,y:248.7},0).wait(2).to({regY:79.5,scaleY:0.43,skewX:-6.1},0).wait(2).to({scaleY:0.45,skewX:-3,x:263.1,y:248.9},0).wait(2).to({regX:-6,regY:81.5,scaleY:0.47,skewX:0,x:264.9,y:249.6},0).wait(2).to({regX:-6.2,scaleY:0.48,x:265.1,y:250.1},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,skewX:0.3,x:261.9,y:249.6},0).wait(2).to({regX:-0.1,scaleY:0.49,x:262.1},0).wait(2).to({regX:-6.9,regY:81.5,scaleY:0.5,skewX:0.5,x:264.9,y:249.7},0).wait(12).to({regX:-7,regY:81.6,scaleY:0.49,skewX:0.3,x:265.4},0).wait(2).to({regX:0.1,regY:81.4,scaleY:0.49,x:261.9,y:249.6},0).wait(2).to({regX:-0.1,regY:81.5,scaleY:0.48,skewX:0,x:262.3,y:249.9},0).wait(2).to({regX:-6,scaleY:0.47,x:264.9,y:249.4},0).wait(1));

	// Tiger Head
	this.instance_24 = new lib.TigerHead_004();
	this.instance_24.parent = this;
	this.instance_24.setTransform(270,171.2,0.515,0.515,0,0,180,33.3,28.2);

	this.instance_25 = new lib.TigerHead_001();
	this.instance_25.parent = this;
	this.instance_25.setTransform(275.1,171.2,0.515,0.515,0,0,180,33.3,28.2);

	this.instance_26 = new lib.TigerHead_002();
	this.instance_26.parent = this;
	this.instance_26.setTransform(314.3,178.5,0.515,0.515,0,-2.8,177.2,-22.7,25.1);

	this.instance_27 = new lib.TigerHead_003();
	this.instance_27.parent = this;
	this.instance_27.setTransform(319.9,183.1,0.515,0.515,0,-4.7,175.3,-22.7,24.4);

	this.instance_28 = new lib.TigerHead_004_wet();
	this.instance_28.parent = this;
	this.instance_28.setTransform(270,171.2,0.515,0.515,0,0,180,33.3,28.2);

	this.instance_29 = new lib.TigerHead_roar_001_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(285.4,177.5,0.515,0.515,0,6.2,-173.8,33,27.7);
	this.instance_29._off = true;

	this.instance_30 = new lib.TigerHead_roar_002_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(280,173.7,0.515,0.515,0,6.2,-173.8,33,27.8);

	this.instance_31 = new lib.TigerHead_roar_004_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(279.2,168.1,0.515,0.515,0,-8.8,171.2,32.4,27.9);
	this.instance_31._off = true;

	this.instance_32 = new lib.TigerHead_roar_003_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(279.7,163.1,0.515,0.515,0,-14.3,165.7,32.6,27.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_24}]}).to({state:[{t:this.instance_24}]},28).to({state:[{t:this.instance_25,p:{regY:28.2,y:171.2}}]},6).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_26,p:{regY:25.1,skewX:-2.8,skewY:177.2,x:314.3,y:178.5}}]},2).to({state:[{t:this.instance_27}]},2).to({state:[{t:this.instance_27}]},109).to({state:[{t:this.instance_26,p:{regY:24.4,skewX:-3.3,skewY:176.7,x:315.1,y:178.7}}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25,p:{regY:28.3,y:174.2}}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25,p:{regY:28.2,y:171.2}}]},94).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},20).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25,p:{regY:28.2,y:171.2}}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_28}]},26).to({state:[{t:this.instance_29}]},26).to({state:[{t:this.instance_29}]},12).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_31}]},18).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},56).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_31}]},12).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_29}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(28).to({_off:true},6).wait(2).to({_off:false,regX:-22.9,regY:25.1,rotation:1,skewY:0,x:285.5,y:173.6},0).to({_off:true},2).wait(115).to({_off:false,y:177.5},0).to({_off:true},2).wait(2).to({_off:false,regX:33.3,regY:28.2,rotation:0,skewY:180,x:270,y:171.2},0).to({_off:true},94).wait(2).to({_off:false,regX:-22.9,regY:25.1,rotation:1,skewY:0,x:285.5,y:173.6},0).wait(2).to({rotation:2.3,x:287.1,y:176.9},0).wait(2).to({regX:-22.4,regY:24.2,rotation:3.3,x:289.1,y:179.6},0).wait(2).to({regX:-22.7,regY:24.4,rotation:4.7,x:290.5,y:183.1},0).wait(22).to({regY:26.9,rotation:3.3,x:288.8,y:181.2},0).wait(2).to({regX:-22.9,regY:24.4,rotation:2.3,x:287.1,y:176.8},0).wait(2).to({regY:25.1,rotation:1,x:285.5,y:173.6},0).to({_off:true},2).wait(2).to({_off:false,regX:33.3,regY:28.2,rotation:0,skewY:180,x:270,y:171.2},0).to({_off:true},26).wait(180));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(341).to({_off:false},0).wait(12).to({y:176.7},0).wait(2).to({y:177.5},0).wait(2).to({regX:32.9,skewX:1.3,skewY:-178.7,x:287.8,y:189.8},0).wait(2).to({regX:33.1,regY:28.2,skewX:-3.5,skewY:-183.5,x:290,y:202.2},0).wait(2).to({regY:28.1,skewX:0,skewY:-180,y:203.9},0).wait(2).to({regX:33,regY:27.9,skewX:3.2,skewY:-176.8,y:205.8},0).wait(2).to({regX:34.2,regY:27.8,skewX:4.5,skewY:-175.5,x:287.1,y:191.5},0).wait(2).to({regX:33,regY:27.7,skewX:6.2,skewY:-173.8,x:285.4,y:177.5},0).to({_off:true},2).wait(30).to({_off:false},0).wait(57).to({y:176.7},0).wait(1).to({y:177.5},0).wait(1).to({regX:32.9,skewX:1.3,skewY:-178.7,x:287.8,y:189.8},0).wait(2).to({regX:33.1,regY:28.2,skewX:-3.5,skewY:-183.5,x:290,y:202.2},0).wait(2).to({regY:28.1,skewX:0,skewY:-180,y:203.9},0).wait(2).to({regX:33,regY:27.9,skewX:3.2,skewY:-176.8,y:205.8},0).wait(2).to({regX:34.2,regY:27.8,skewX:4.5,skewY:-175.5,x:287.1,y:191.5},0).wait(2).to({regX:33,regY:27.7,skewX:6.2,skewY:-173.8,x:285.4,y:177.5},0).to({_off:true},2).wait(24).to({_off:false},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(371).to({_off:false},0).wait(2).to({regX:32.9,regY:27.7,skewX:-14.7,skewY:165.3,x:279.7,y:168},0).to({_off:true},2).wait(18).to({_off:false},0).wait(2).to({regX:32.4,regY:27.9,skewX:-8.8,skewY:171.2,x:279.2,y:168.1},0).to({_off:true},2).wait(75).to({_off:false},0).wait(2).to({regX:32.9,regY:27.7,skewX:-14.7,skewY:165.3,x:279.7,y:168},0).to({_off:true},2).wait(12).to({_off:false},0).wait(2).to({regX:32.4,regY:27.9,skewX:-8.8,skewY:171.2,x:279.2,y:168.1},0).to({_off:true},2).wait(3));

	// Tiger Neck
	this.instance_33 = new lib.TigerNeck_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(284,169.9,0.468,0.468,0,0,180);

	this.instance_34 = new lib.TigerNeck_wet_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(284,169.9,0.468,0.468,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_33}]},28).to({state:[{t:this.instance_33}]},8).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},109).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},96).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},20).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_34}]},28).to({state:[{t:this.instance_33}]},26).to({state:[{t:this.instance_33}]},12).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},18).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},56).to({state:[{t:this.instance_33}]},1).to({state:[{t:this.instance_33}]},1).to({state:[{t:this.instance_33}]},1).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},12).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).to({state:[{t:this.instance_33}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(36).to({scaleX:0.49,scaleY:0.47,skewX:2.8,skewY:184,x:285.1,y:172.5},0).wait(2).to({scaleX:0.52,scaleY:0.46,skewX:7.1,skewY:190.3,x:286.7,y:176.5},0).wait(2).to({scaleX:0.55,scaleY:0.46,skewX:11.7,skewY:196.8,x:288.2,y:180.5},0).wait(111).to({scaleX:0.53,scaleY:0.46,skewX:8.6,skewY:192.5,x:287.1,y:177.8},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:5.8,skewY:188.3,x:286.1,y:175.2},0).wait(2).to({scaleX:0.49,scaleY:0.47,skewX:2.8,skewY:184,x:285.1,y:172.5},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:284,y:169.9},0).wait(96).to({scaleX:0.49,scaleY:0.47,skewX:2.8,skewY:184,x:285.1,y:172.5},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:5.8,skewY:188.3,x:286.1,y:175.2},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:8.6,skewY:192.5,x:287.2,y:177.9},0).wait(2).to({scaleX:0.55,scaleY:0.46,skewX:11.7,skewY:196.8,x:288.2,y:180.5},0).wait(22).to({scaleX:0.53,scaleY:0.46,skewX:8.6,skewY:192.5,x:287.1,y:177.8},0).wait(2).to({scaleX:0.51,scaleY:0.46,skewX:5.8,skewY:188.3,x:286.1,y:175.2},0).wait(2).to({scaleX:0.49,scaleY:0.47,skewX:2.8,skewY:184,x:285.1,y:172.5},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:284,y:169.9},0).to({_off:true},28).wait(26).to({_off:false,regX:24.2,regY:9.7,x:272.7,y:174.4},0).wait(12).to({regY:9.8,y:173.7},0).wait(2).to({regY:9.7,y:174.4},0).wait(2).to({scaleX:0.5,scaleY:0.46,skewX:17.8,skewY:197.8,x:271.5,y:178.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,skewX:35.6,skewY:215.6,x:270.3,y:182.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:270.4,y:184.8},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:270.3,y:187.2},0).wait(2).to({regY:9.8,scaleX:0.5,scaleY:0.46,skewX:17.8,skewY:197.8,x:271.5,y:180.9},0).wait(2).to({regY:9.7,scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:272.7,y:174.4},0).wait(4).to({regX:23.9,regY:10.2,scaleX:0.59,scaleY:0.45,skewX:-1.1,skewY:179,x:267.8,y:169.3},0).wait(2).to({skewX:-5.1,skewY:175,x:269.3,y:168.3},0).wait(2).to({regY:10.1,skewX:-9.4,skewY:170.8,x:271,y:167.3},0).wait(18).to({regX:25.4,regY:8.8,skewX:-5.1,skewY:175,x:268.5,y:167.7},0).wait(2).to({regX:23.9,regY:10.2,skewX:-1.1,skewY:179,x:267.8,y:169.3},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:-0.5,skewY:179.7,x:270.3,y:171.9},0).wait(2).to({regX:24.2,regY:9.7,scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:272.7,y:174.4},0).wait(57).to({regY:9.8,y:173.7},0).wait(1).to({regY:9.7,y:174.4},0).wait(1).to({scaleX:0.5,scaleY:0.46,skewX:17.8,skewY:197.8,x:271.5,y:178.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,skewX:35.6,skewY:215.6,x:270.3,y:182.4},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:270.4,y:184.8},0).wait(2).to({scaleX:0.52,scaleY:0.46,x:270.3,y:187.2},0).wait(2).to({regY:9.8,scaleX:0.5,scaleY:0.46,skewX:17.8,skewY:197.8,x:271.5,y:180.9},0).wait(2).to({regY:9.7,scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:272.7,y:174.4},0).wait(4).to({regX:23.9,regY:10.2,scaleX:0.59,scaleY:0.45,skewX:-1.1,skewY:179,x:267.8,y:169.3},0).wait(2).to({skewX:-5.1,skewY:175,x:269.3,y:168.3},0).wait(2).to({regY:10.1,skewX:-9.4,skewY:170.8,x:271,y:167.3},0).wait(12).to({regX:25.4,regY:8.8,skewX:-5.1,skewY:175,x:268.5,y:167.7},0).wait(2).to({regX:23.9,regY:10.2,skewX:-1.1,skewY:179,x:267.8,y:169.3},0).wait(2).to({scaleX:0.53,scaleY:0.46,skewX:-0.5,skewY:179.7,x:270.3,y:171.9},0).wait(2).to({regX:24.2,regY:9.7,scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:272.7,y:174.4},0).wait(1));

	// Tiger Hind Leg
	this.instance_35 = new lib.TigerHindLeg();
	this.instance_35.parent = this;
	this.instance_35.setTransform(184.8,178,0.468,0.468,0,0,180,-14.3,-58.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(36).to({regX:-16.3,regY:-58.6,skewX:0.3,x:186.2},0).wait(2).to({regX:-16.2,regY:-58.7,skewX:0.8,x:186.7,y:177.9},0).wait(2).to({regX:-14.2,skewX:1.3,x:186.5,y:178},0).wait(111).to({skewX:0.8,x:185.8},0).wait(2).to({regX:-14.3,skewX:0.5,x:185.3,y:177.9},0).wait(2).to({regX:-16.3,regY:-58.6,skewX:0.3,x:186,y:178},0).wait(2).to({regX:-14.3,regY:-58.7,skewX:0,x:184.8},0).wait(96).to({regX:-16.3,regY:-58.6,skewX:0.3,x:186.2},0).wait(2).to({regX:-16.2,regY:-58.7,skewX:0.5,x:186.4,y:177.9},0).wait(2).to({skewX:0.8,x:187,y:178},0).wait(2).to({regX:-14.2,skewX:1.3,x:186.5},0).wait(22).to({skewX:0.8,x:186},0).wait(2).to({regX:-14.3,skewX:0.5,x:185.7,y:177.9},0).wait(2).to({regX:-16.3,regY:-58.6,skewX:0.3,x:186.2,y:178},0).wait(2).to({regX:-14.3,regY:-58.7,skewX:0,x:184.8},0).wait(66).to({regX:0.1,regY:94.5,scaleY:0.48,x:178.1,y:249.6},0).wait(2).to({regY:94.4,skewX:0.4},0).wait(2).to({skewX:1},0).wait(2).to({skewX:1.6},0).wait(2).to({scaleY:0.48,skewX:2.5},0).wait(2).to({scaleY:0.49,skewX:3.5,y:249.5},0).wait(2).to({regX:0.8,scaleY:0.48,skewX:1.8,x:177.9,y:249.6},0).wait(2).to({regX:0.1,scaleY:0.48,skewX:0.4,x:178.1},0).wait(2).to({scaleY:0.46,skewX:0,x:178},0).wait(2).to({regX:10.3,scaleY:0.45,skewX:-0.4,x:173.3},0).wait(2).to({regX:6,skewX:0,x:175.1},0).wait(2).to({regX:0.3,skewX:0.7,x:177.8},0).wait(18).to({regX:0.2,skewX:0,x:178.2},0).wait(2).to({regX:6.2,skewX:-0.4,x:175.5},0).wait(2).to({regX:6.1,scaleY:0.46,skewX:0,x:175.4},0).wait(2).to({regX:0.1,scaleY:0.48,skewX:0.4,x:178.1},0).wait(56).to({regX:-14.3,regY:-58.7,scaleY:0.47,skewX:0,x:184.8,y:178},0).wait(1).to({regX:0.1,regY:94.5,scaleY:0.48,x:178.1,y:249.6},0).wait(1).to({regY:94.4,skewX:0.4},0).wait(1).to({skewX:1},0).wait(2).to({skewX:1.6},0).wait(2).to({scaleY:0.48,skewX:2.5},0).wait(2).to({scaleY:0.49,skewX:3.5,y:249.5},0).wait(2).to({regX:0.8,scaleY:0.48,skewX:1.8,x:177.9,y:249.6},0).wait(2).to({regX:0.1,scaleY:0.48,skewX:0.4,x:178.1},0).wait(2).to({scaleY:0.46,skewX:0,x:178},0).wait(2).to({regX:10.5,scaleY:0.45,skewX:-0.4,x:173.2},0).wait(2).to({regX:6,skewX:0,x:175.1},0).wait(2).to({regX:0.3,skewX:0.7,x:177.8},0).wait(12).to({regX:0.2,skewX:0,x:178.2},0).wait(2).to({regX:6.2,skewX:-0.4,x:175.5},0).wait(2).to({regX:6.1,scaleY:0.46,skewX:0,x:175.4},0).wait(2).to({regX:0.1,scaleY:0.48,skewX:0.4,x:178.1},0).wait(1));

	// Tiger Front Leg
	this.instance_36 = new lib.TigerFrontLeg();
	this.instance_36.parent = this;
	this.instance_36.setTransform(260.8,182.7,0.468,0.468,0,0,180,2.9,-61.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(36).to({scaleY:0.46,skewX:0.3,x:261.2,y:184.1},0).wait(2).to({scaleY:0.44,skewX:0.8,x:261.8,y:186.3},0).wait(2).to({scaleY:0.43,skewX:1.6,x:262.4,y:188.3},0).wait(111).to({scaleY:0.44,skewX:1,x:262,y:186.9},0).wait(2).to({regX:9,scaleY:0.45,skewX:0.6,x:258.7,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.46,skewX:0.3,x:261.2,y:184.1},0).wait(2).to({scaleY:0.47,skewX:0,x:260.8,y:182.7},0).wait(96).to({scaleY:0.46,skewX:0.3,x:261.2,y:184.1},0).wait(2).to({regX:8.8,scaleY:0.45,skewX:0.6,x:258.8,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.44,skewX:1,x:262,y:186.9},0).wait(2).to({scaleY:0.43,skewX:1.6,x:262.4,y:188.3},0).wait(22).to({scaleY:0.44,skewX:1,x:262,y:186.9},0).wait(2).to({regX:9,scaleY:0.45,skewX:0.6,x:258.7,y:185.5},0).wait(2).to({regX:2.9,scaleY:0.46,skewX:0.3,x:261.2,y:184.1},0).wait(2).to({scaleY:0.47,skewX:0,x:260.8,y:182.7},0).wait(28).to({_off:true},26).wait(154));

	// Tiger Torso
	this.instance_37 = new lib.TigerTorso();
	this.instance_37.parent = this;
	this.instance_37.setTransform(243.3,173.1,0.468,0.468,0,0,180,-51.5,0);

	this.instance_38 = new lib.TigerTorso_wet();
	this.instance_38.parent = this;
	this.instance_38.setTransform(243.3,173.1,0.468,0.468,0,0,180,-51.5,0);

	this.instance_39 = new lib.TigerTorso_roar_001_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(243.3,173.1,0.468,0.468,0,0,180,-51.5,0);
	this.instance_39._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_37}]},28).to({state:[{t:this.instance_37}]},8).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},109).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},96).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},20).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_37}]},2).to({state:[{t:this.instance_38}]},28).to({state:[{t:this.instance_39}]},26).to({state:[{t:this.instance_39}]},12).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},18).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},56).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},12).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).to({state:[{t:this.instance_39}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(36).to({regX:-51.8,skewX:1,skewY:181,x:244,y:174.3},0).wait(2).to({regX:-51.6,regY:-0.1,skewX:2.8,skewY:182.8,x:244.7,y:176},0).wait(2).to({regY:0.1,skewX:4.7,skewY:184.7,x:245.5,y:178},0).wait(111).to({regX:-51.5,regY:0,skewX:3.3,skewY:183.3,x:245,y:176.7},0).wait(2).to({regX:-51.6,regY:0.1,skewX:2.3,skewY:182.3,x:244.5,y:175.5},0).wait(2).to({regX:-51.8,regY:0,skewX:1,skewY:181,x:244,y:174.3},0).wait(2).to({regX:-51.5,skewX:0,skewY:180,x:243.3,y:173.1},0).wait(96).to({regX:-51.8,skewX:1,skewY:181,x:244,y:174.3},0).wait(2).to({regX:-51.6,regY:0.1,skewX:2.3,skewY:182.3,x:244.5,y:175.5},0).wait(2).to({regX:-51.8,regY:0,skewX:3.3,skewY:183.3,x:245,y:176.7},0).wait(2).to({regX:-51.6,regY:0.1,skewX:4.7,skewY:184.7,x:245.5,y:178},0).wait(22).to({regX:-51.5,regY:0,skewX:3.3,skewY:183.3,x:245,y:176.7},0).wait(2).to({regX:-51.6,regY:0.1,skewX:2.3,skewY:182.3,x:244.5,y:175.5},0).wait(2).to({regX:-51.8,regY:0,skewX:1,skewY:181,x:244,y:174.3},0).wait(2).to({regX:-51.5,skewX:0,skewY:180,x:243.3,y:173.1},0).to({_off:true},28).wait(180));
	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(341).to({_off:false},0).wait(12).to({y:172.3},0).wait(2).to({y:173.1},0).wait(2).to({regX:-51.6,scaleX:0.47,scaleY:0.47,skewX:5,skewY:185,x:245.5,y:176.2},0).wait(2).to({regX:-51.5,skewX:10.3,skewY:190.3,x:247.6,y:179.4},0).wait(2).to({regX:-51.6,regY:0.6,skewX:12.6,skewY:192.6,y:181.2},0).wait(2).to({regX:-51.5,regY:0,skewX:15,skewY:195,y:182.6},0).wait(2).to({skewX:7.5,skewY:187.5,x:245.5,y:177.8},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:243.3,y:173.1},0).wait(2).to({regX:-51.6,skewX:-2.3,skewY:177.7,x:243.4},0).wait(2).to({regX:-51.5,skewX:-5,skewY:175,x:243.3},0).wait(2).to({regY:-0.1,skewX:-6.3,skewY:173.7,x:243.9,y:172.2},0).wait(2).to({regX:-51.6,skewX:-7.7,skewY:172.3,x:244.5,y:171.4},0).wait(18).to({regX:-51.5,regY:0,skewX:-6.3,skewY:173.7,x:243.9,y:172.3},0).wait(2).to({skewX:-5,skewY:175,x:243.3,y:173.1},0).wait(2).to({skewX:-2.3,skewY:177.7},0).wait(2).to({skewX:0,skewY:180},0).wait(57).to({y:172.3},0).wait(1).to({y:173.1},0).wait(1).to({regX:-51.6,scaleX:0.47,scaleY:0.47,skewX:5,skewY:185,x:245.5,y:176.2},0).wait(2).to({regX:-51.5,skewX:10.3,skewY:190.3,x:247.6,y:179.4},0).wait(2).to({regX:-51.6,regY:0.6,skewX:12.6,skewY:192.6,y:181.2},0).wait(2).to({regX:-51.5,regY:0,skewX:15,skewY:195,y:182.6},0).wait(2).to({skewX:7.5,skewY:187.5,x:245.5,y:177.8},0).wait(2).to({scaleX:0.47,scaleY:0.47,skewX:0,skewY:180,x:243.3,y:173.1},0).wait(2).to({regX:-51.6,skewX:-2.3,skewY:177.7,x:243.4},0).wait(2).to({regX:-51.5,skewX:-5,skewY:175,x:243.3},0).wait(2).to({regY:-0.1,skewX:-6.3,skewY:173.7,x:243.9,y:172.2},0).wait(2).to({regX:-51.6,skewX:-7.7,skewY:172.3,x:244.5,y:171.4},0).wait(12).to({regX:-51.5,regY:0,skewX:-6.3,skewY:173.7,x:243.9,y:172.3},0).wait(2).to({skewX:-5,skewY:175,x:243.3,y:173.1},0).wait(2).to({skewX:-2.3,skewY:177.7},0).wait(2).to({skewX:0,skewY:180},0).wait(1));

	// Tiger Tail
	this.instance_40 = new lib.TigerTail_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(177.1,169,0.468,0.468,0,0,180,-30.1,-54.4);

	this.instance_41 = new lib.TigerTail_loop();
	this.instance_41.parent = this;
	this.instance_41.setTransform(177.1,169,0.468,0.468,0,0,180,-30.1,-54.4);
	this.instance_41._off = true;

	this.instance_42 = new lib.TigerTailLoop2();
	this.instance_42.parent = this;
	this.instance_42.setTransform(179,169,0.468,0.468,0,9.9,-170.1,-30.1,-54.6);
	this.instance_42._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_40}]}).to({state:[{t:this.instance_41}]},28).to({state:[{t:this.instance_41}]},8).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_41}]},109).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_42}]},16).to({state:[{t:this.instance_41}]},72).to({state:[{t:this.instance_41}]},8).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},20).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_41}]},2).to({state:[{t:this.instance_40}]},6).to({state:[{t:this.instance_40}]},22).to({state:[{t:this.instance_42}]},26).to({state:[{t:this.instance_42}]},12).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},18).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},56).to({state:[{t:this.instance_42}]},1).to({state:[{t:this.instance_42}]},1).to({state:[{t:this.instance_42}]},1).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},12).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).to({state:[{t:this.instance_42}]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_41).wait(28).to({_off:false},0).wait(8).to({regX:-28.2,regY:-54.2,skewX:2.3,skewY:182.3,x:176.6},0).wait(2).to({regX:-28.3,regY:-54.4,skewX:6,skewY:186,x:177.8,y:168.9},0).to({_off:true},2).wait(109).to({_off:false,regX:-30.1,regY:-54.6,skewX:9.9,skewY:189.9,x:179,y:169},0).wait(2).to({regX:-30,regY:-54.4,skewX:7.3,skewY:187.3,x:178.1,y:169.1},0).wait(2).to({regY:-54.5,skewX:4.8,skewY:184.8,x:177.4,y:169},0).wait(2).to({regX:-28.2,regY:-54.2,skewX:2.3,skewY:182.3,x:176.6},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:0,skewY:180,x:177.1},0).to({_off:true},16).wait(72).to({_off:false},0).wait(8).to({regX:-28.2,regY:-54.2,skewX:2.3,skewY:182.3,x:176.6},0).wait(2).to({regX:-28.3,regY:-54.3,skewX:4.8,skewY:184.8,x:177.4},0).wait(2).to({regX:-27.6,regY:-53.8,skewX:7.3,skewY:187.3,x:177.9,y:169.2},0).wait(2).to({regX:-30.1,regY:-54.6,skewX:9.9,skewY:189.9,x:179,y:169},0).wait(22).to({regX:-30,regY:-54.4,skewX:7.3,skewY:187.3,x:178.1,y:169.1},0).wait(2).to({regY:-54.5,skewX:4.8,skewY:184.8,x:177.4,y:169},0).wait(2).to({regX:-28.2,regY:-54.2,skewX:2.3,skewY:182.3,x:176.6},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:0,skewY:180,x:177.1},0).to({_off:true},6).wait(202));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).wait(40).to({_off:false},0).to({_off:true},109).wait(24).to({_off:false,regY:-54.4,skewX:0,skewY:-180,x:177.1},0).to({_off:true},72).wait(96).to({_off:false},0).wait(12).to({regY:-54.5,skewX:-2.7,skewY:-182.7,x:177},0).wait(2).to({regY:-54.4,skewX:0,skewY:-180,x:177.1},0).wait(2).to({regX:-30.2,regY:-54.8,scaleX:0.47,scaleY:0.47,skewX:7.3,skewY:-172.7,x:180,y:166.2},0).wait(2).to({regX:-30.4,regY:-53.5,skewX:14.5,skewY:-165.5,x:182.8,y:163.8},0).wait(2).to({regY:-53.3,skewX:16.8,skewY:-163.2,y:163.6},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:19,skewY:-161,y:163.4},0).wait(2).to({regX:-30.2,regY:-54.3,skewX:9.5,skewY:-170.5,x:179.9,y:166.3},0).wait(2).to({regX:-30.1,regY:-54.4,scaleX:0.47,scaleY:0.47,skewX:0,skewY:-180,x:177.1,y:169},0).wait(2).to({regX:-30.2,regY:-54.5,skewX:1.3,skewY:-178.7,x:177.2,y:171.4},0).wait(2).to({regX:-27.4,regY:-54.8,skewX:2.7,skewY:-177.3,x:177.4,y:173.9},0).wait(2).to({regY:-55,skewX:0,skewY:-180,x:178.8,y:174},0).wait(2).to({regX:-29.8,regY:-54.6,skewX:-2.5,skewY:-182.5,x:180.2,y:174.1},0).wait(18).to({regY:-55,skewX:0,skewY:-180,x:178.8,y:173.8},0).wait(2).to({regX:-27.4,regY:-54.8,skewX:2.7,skewY:-177.3,x:177.4,y:173.9},0).wait(2).to({regY:-54.7,skewX:1.3,skewY:-178.7,x:177.2,y:171.5},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:0,skewY:-180,x:177.1,y:169},0).wait(57).to({regY:-54.5,skewX:-2.7,skewY:-182.7,x:177},0).wait(1).to({regY:-54.4,skewX:0,skewY:-180,x:177.1},0).wait(1).to({regX:-30.2,regY:-54.8,scaleX:0.47,scaleY:0.47,skewX:7.3,skewY:-172.7,x:180,y:166.2},0).wait(2).to({regX:-30.4,regY:-53.5,skewX:14.5,skewY:-165.5,x:182.8,y:163.8},0).wait(2).to({regY:-53.3,skewX:16.8,skewY:-163.2,y:163.6},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:19,skewY:-161,y:163.4},0).wait(2).to({regX:-30.2,regY:-54.3,skewX:9.5,skewY:-170.5,x:179.9,y:166.3},0).wait(2).to({regX:-30.1,regY:-54.4,scaleX:0.47,scaleY:0.47,skewX:0,skewY:-180,x:177.1,y:169},0).wait(2).to({regX:-30.2,regY:-54.5,skewX:1.3,skewY:-178.7,x:177.2,y:171.4},0).wait(2).to({regX:-27.4,regY:-54.8,skewX:2.7,skewY:-177.3,x:177.4,y:173.9},0).wait(2).to({regY:-55,skewX:0,skewY:-180,x:178.8,y:174},0).wait(2).to({regX:-29.8,regY:-54.6,skewX:-2.5,skewY:-182.5,x:180.2,y:174.1},0).wait(12).to({regY:-55,skewX:0,skewY:-180,x:178.8,y:173.8},0).wait(2).to({regX:-27.4,regY:-54.8,skewX:2.7,skewY:-177.3,x:177.4,y:173.9},0).wait(2).to({regY:-54.7,skewX:1.3,skewY:-178.7,x:177.2,y:171.5},0).wait(2).to({regX:-30.1,regY:-54.4,skewX:0,skewY:-180,x:177.1,y:169},0).wait(1));

	// Tiger Hind Leg Back
	this.instance_43 = new lib.TigerHindLegBack();
	this.instance_43.parent = this;
	this.instance_43.setTransform(197.3,176.6,0.468,0.468,0,0,180,-14.3,-51.6);

	this.instance_44 = new lib.TigerHindLegBackcopy();
	this.instance_44.parent = this;
	this.instance_44.setTransform(197.3,176.6,0.468,0.468,0,0,180,-14.3,-51.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_43}]}).to({state:[{t:this.instance_43}]},28).to({state:[{t:this.instance_43}]},8).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},109).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},96).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},20).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},2).to({state:[{t:this.instance_43}]},28).to({state:[{t:this.instance_44}]},26).to({state:[{t:this.instance_44}]},114).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.instance_43).wait(36).to({regX:-14,regY:-51.5,skewX:0.3,x:197.6,y:176.7},0).wait(2).to({skewX:0.8,x:198.3,y:176.6},0).wait(2).to({regX:-14.3,regY:-51.6,skewX:1.3,x:198.9},0).wait(111).to({regY:-51.5,skewX:0.8,x:198.5,y:176.7},0).wait(2).to({regX:-14,skewX:0.5,x:197.8},0).wait(2).to({skewX:0.3,x:197.6},0).wait(2).to({regX:-14.3,regY:-51.6,skewX:0,x:197.3,y:176.6},0).wait(96).to({regX:-14,regY:-51.5,skewX:0.3,x:197.6,y:176.7},0).wait(2).to({regX:-7.9,skewX:0.5,x:195.2},0).wait(2).to({regX:-13.8,skewX:0.8,x:198.4},0).wait(2).to({regX:-14.3,regY:-51.6,skewX:1.3,x:198.9,y:176.6},0).wait(22).to({regY:-51.5,skewX:0.8,x:198.5,y:176.7},0).wait(2).to({regX:-14,skewX:0.5,x:197.8},0).wait(2).to({skewX:0.3,x:197.6},0).wait(2).to({regX:-14.3,regY:-51.6,skewX:0,x:197.3,y:176.6},0).wait(28).to({_off:true},26).wait(154));

	// Tiger Front Leg Back
	this.instance_45 = new lib.TigerFrontLegBack();
	this.instance_45.parent = this;
	this.instance_45.setTransform(272.7,176.4,0.468,0.468,0,0,180,0,-63);

	this.timeline.addTween(cjs.Tween.get(this.instance_45).wait(36).to({scaleY:0.46,skewX:0.3,x:273.1,y:177.8},0).wait(2).to({scaleY:0.44,skewX:0.8,x:273.7,y:179.9},0).wait(2).to({regX:-0.1,regY:-63.1,scaleY:0.43,skewX:1.6,x:274.4,y:182},0).wait(111).to({scaleY:0.44,skewX:1,x:273.9,y:180.7},0).wait(2).to({regX:0.8,scaleY:0.45,skewX:0.6,x:273.1,y:179.2},0).wait(2).to({regX:0,regY:-63,scaleY:0.46,skewX:0.3,y:177.8},0).wait(2).to({scaleY:0.47,skewX:0,x:272.7,y:176.4},0).wait(96).to({scaleY:0.46,skewX:0.3,x:273.1,y:177.8},0).wait(2).to({regX:0.1,scaleY:0.45,skewX:0.6,x:273.4,y:179.2},0).wait(2).to({regX:-0.1,scaleY:0.44,skewX:1,x:274,y:180.6},0).wait(2).to({regY:-63.1,scaleY:0.43,skewX:1.6,x:274.4,y:182},0).wait(22).to({scaleY:0.44,skewX:1,x:273.9,y:180.7},0).wait(2).to({regX:0.8,scaleY:0.45,skewX:0.6,x:273.1,y:179.2},0).wait(2).to({regX:0,regY:-63,scaleY:0.46,skewX:0.3,y:177.8},0).wait(2).to({scaleY:0.47,skewX:0,x:272.7,y:176.4},0).wait(66).to({regX:-5.5,regY:79.6,scaleY:0.48,x:275.2,y:243.1},0).wait(2).to({regY:79.7,scaleY:0.46},0).wait(2).to({regX:-9.8,scaleY:0.47,skewX:-3.5,x:277.5},0).wait(2).to({regX:-6.2,scaleY:0.47,skewX:-7.2,x:275.6},0).wait(2).to({scaleY:0.47,skewX:-8.5,x:275.5},0).wait(2).to({regX:-5.9,scaleY:0.47,skewX:-9.8,x:275.4},0).wait(2).to({regY:79.6,scaleY:0.47,skewX:-4.8,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:275.2,y:243.1},0).wait(2).to({regX:-5.4,regY:79.8,scaleY:0.46,skewX:-2,y:243.2},0).wait(2).to({regY:79.7,skewX:-4.1,y:243.1},0).wait(2).to({scaleY:0.47,skewX:-4,x:275.1},0).wait(2).to({regX:-0.5,scaleY:0.48,skewX:-4.1,x:272.9},0).wait(18).to({regX:-4.9,regY:79.5,scaleY:0.47,skewX:-4,x:275.2,y:243},0).wait(2).to({regX:-5.4,regY:79.7,scaleY:0.46,skewX:-4.1,y:243.1},0).wait(2).to({regY:79.8,skewX:-2,x:275.3,y:243.2},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:275.2,y:243.1},0).wait(56).to({regX:0,regY:-63,scaleY:0.47,x:272.7,y:176.4},0).wait(1).to({regX:-5.5,regY:79.6,scaleY:0.48,x:275.2,y:243.1},0).wait(1).to({regY:79.7,scaleY:0.46},0).wait(1).to({regX:-9.9,scaleY:0.47,skewX:-3.5,x:277.5},0).wait(2).to({regX:-6.2,scaleY:0.47,skewX:-7.2,x:275.6},0).wait(2).to({scaleY:0.47,skewX:-8.5,x:275.5},0).wait(2).to({regX:-5.9,scaleY:0.47,skewX:-9.8,x:275.4},0).wait(2).to({regY:79.6,scaleY:0.47,skewX:-4.8,y:243},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:275.2,y:243.1},0).wait(2).to({regX:-5.4,regY:79.8,scaleY:0.46,skewX:-2,y:243.2},0).wait(2).to({regY:79.7,skewX:-4.1,y:243.1},0).wait(2).to({scaleY:0.47,skewX:-4,x:275.1},0).wait(2).to({regX:-0.4,scaleY:0.48,skewX:-4.1,x:272.9},0).wait(12).to({regX:-4.9,regY:79.5,scaleY:0.47,skewX:-4,x:275.2,y:243},0).wait(2).to({regX:-5.4,regY:79.7,scaleY:0.46,skewX:-4.1,y:243.1},0).wait(2).to({regY:79.8,skewX:-2,x:275.3,y:243.2},0).wait(2).to({regX:-5.5,regY:79.7,scaleY:0.46,skewX:0,x:275.2,y:243.1},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(436.8,285.7,173.8,124);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWtiger_atlas_.png?1528311868463", id:"MWtiger_atlas_"},
		{src:"sounds/GleamAfterDrying5wav.mp3?1528311868948", id:"GleamAfterDrying5wav"},
		{src:"sounds/sesame_murray_bengal_tiger_01_distant_purr_01.mp3?1528311868948", id:"sesame_murray_bengal_tiger_01_distant_purr_01"},
		{src:"sounds/sesame_murray_bengal_tiger_04_close_purr_02.mp3?1528311868948", id:"sesame_murray_bengal_tiger_04_close_purr_02"},
		{src:"sounds/sesame_murray_bengal_tiger_06_outro_roar.mp3?1528311868948", id:"sesame_murray_bengal_tiger_06_outro_roar"}
	],
	preloads: []
};




})(lib_Tiger = lib_Tiger||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Tiger, images, createjs, ss, AdobeAn;